import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
// Ready translated locale messages
const messages = {
    cn: {
        message: {
            Categories: "商品分类",
            Community: "社区",
            Save: "保存",
            Register: "注册",
            Sign_Up: "注册",
            Login: "登录",
            UserName: "用户名",
            News: "新闻",
            Service: "服务",
            Memberships: "会员关系",
            AllProducts:"所有产品",
            Aboutus: "关于我们",
            Support: "支持",
            Corporate: "企业",
            Customized_Service: "定制服务",
            APP_Download: "APP下载",
            Instruction_Book: "说明书下载",
            Video: "视频",
            Forum: "论坛",
            Password: "密码",
            LOST_PASSWORD: "忘记密码?",
            Username_Email_Phone: "用户名/邮箱/电话号码",
            Sign_Up_Failed: "注册失败",
            email: "邮箱",
            My_Cart: "我的购物车",
            CART_TOTAL: "合计",
            POST: "发帖",
            Company: "公司资讯",
            Service_Item: "服务项目",
            Company_Dynamic: "公司动态",
            Talent_Recruitment: "人才招募",
            Cooperation: "合作",
            After_sale: "售后",
            Product_Verification: "防伪查询:",
            Read_more: "更多",
            Commit: "提交",
            Title: "主题",
            Please_Enter_Title: "请输入标题",
            Please_Enter_Topic_Type: "请选择主题",
            Topic_Type: "主题分类",
            You_need_fill_all_input: "请填上所有选项!!",
            Please_Log_In: "请登录",
            The_Comment_Is_Blank: "评论不能为空!",
            STOCK: "库存",
            QUANTITY: "数量",
            ADD_TO_CART: "加入购物车",
            Product_Description: "产品描述",
            COLORS: "颜色",
            COLOR: "颜色",
            Load_More: "加载更多",
            Insufficient_quantity: "数量不足",
            Add_Success: "添加成功",
            Shopping_Bag: "购物车",
            Checkout_Details: "付款细节",
            Complete_Order: "完成支付",
            Description: "产品信息	",
            Shipping_Itmes: "产品信息  ",
            Customize_message: "定制信息	",
            Subtotal: "小计",
            Total: "总计",
            Submit_Order: "提交订单",
            The_Cart_Empty: "购物车为空",
            SHOPPING_CART_TOTALS: "我的购物车",
            Transaction_Record: "交易记录",
            My_Order: "订单列表",
            Change_Password: "修改密码",
            Welcome_you: "欢迎你",
            Personal_Center: "个人中心",
            Reply: "回复",
            Tran_Addr: "配送地址",
            Manual: "操作手册",
            Security: "防伪",
            Customize: "定制",
            Promotions: "相关促销",
            Bluedio_News: "蓝弦新闻",
            Product_Name: "产品名",
            Count: "数量",
            Price: "价格",
            Unpaid_Order: "未支付",
            Paid_Order: "已支付",
            Order_Number: "订单号",
            Order_Date: "日期",
            Payment_Way: "支付方式",
            Total: "金额",
            Recruit: "招募",
            Order_Status: "交易状态",
            Logout: "登出",
            Confirm_Psw: "确认密码",
            Retrieve_Password: "找回密码",
            Email_Not_Ass_Usr: "没有找到与邮箱关联的用户.",
            Next_Step: "下一步",
            Welcome_to_Bluedio_mall: "蓝弦商城欢迎您",
            You_logout: "您还没有登录",
            Customize_your_product: "定制您的专属产品",
            None: "算了",
            Sure: "确定",
            Cancle: "取消",
            Addr: "地址",
            Tel: "电话号码",
            Shipping_address: "收货地址",
            Success: "成功",
            To_Checkout: "去支付",
            Billing_Address: "寄付帐单地址",
            Total_Amount: "总价",
            Currency_Code: "货币代码",
            Your_Contact_Information: "您的联系方式",
            Telephone_Format: "电话号码",
            Please_Enter_Phone: "请输入电话号码",
            Please_Enter_UsrName: "请输入用户名",
            Please_Enter_Passward: "请输入密码",
            Please_Enter_Passward_Again: "请再次输入密码",
            Please_enter_the_coupon_code: "请输入优惠码",
            Commission_account: "佣金流水帐",
            Brokerage: "佣金",
            Related_Video_Recommendation: "相关视频推荐",
            All: "所有",
            Headband: "头戴式",
            In_ear: "入耳式",
            Sound: "音响",
            Others: "其他",
            Buyer: "购买者",
            Current_commission: "当前佣金",
            Withdraw: "提现",
            Withdraw_time: "确认收货后30天后可提现",
            Share_0: "成为蓝弦销售伙伴的规则:",
            Share_1: "2019年7月1号之前在蓝弦官网消费即可自动升级成为蓝弦伙伴;",
            Share_2: "2019年7月1号之后则需在蓝弦官网购物满￥1500才能获得销售伙伴资格;",
            Share_3: "蓝弦销售伙伴用本人帐号在官网下单一律优惠20%;",
            Share_4: "蓝弦销售伙伴在个人中心获取专属的数字码",
            Share_5: "用户使用销售伙伴的专属数字码购买产品即享5%的优惠;",
            Share_6: "提供数字码的销售伙伴将获得20%的佣金奖励;",
            Share_7: "销售伙伴可根据[佣金赚取栏]了解产品购买状态;",
            Share_8: "当[佣金赚取栏]显示可提现时,联系蓝弦官方提现;",
            Please_enter_the_email: "请输入邮箱",
            Submit: "提交",
            Psw_Same: "两次密码请一致",
            Discount_price: "优惠价",
            Recommendation_code: "您的推荐码",
            Enter_your_product_code: "输入您的产品码",
            Add_cart: "已加入购物车",
            Buy_now: "立即购买",
            Coupon_now: "会员优惠",
            Usr_Psw_Erro: "用户名或密码错误.",
            Not_member: "您还不是蓝弦销售伙伴.",
            Can_withdraw: "可提现",
            Pre_acquisition: "预提现",
            Invalid: "无效",
            Commit_failed: "提交失败",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1虚拟声卡驱动",
            Bluedio_Mall: "蓝弦官方商城",
            Bluedio_Mall_Tagline: "专业音频设备制造商",
            Bluedio_Mall_Keywords: "蓝牙耳塞,无线耳机,降噪无线耳机,运动耳机,真正的无线耳塞,蓝牙耳机,游戏耳机,无线耳机,蓝牙扬声器,便携式扬声器,电脑扬声器,家庭影院扬声器,室外扬声器,无线扬声器,笔记本电脑扬声器,个人电脑扬声器,台式机扬声器",
            Bluedio_Mall_Description: "Bluedio是一家集开发，制造和营销于一体的专业音频设备公司，我们在这一领域已有20多年的历史。 到目前为止，我们已经能够进行设计，软件和硬件开发，结构零件生产，整个设备组装和销售。 并基于数据，与用户中心一起深入开发生态服务能力，我们是整个产业链中最快的独立开发和生产产品的公司。 致力于促进无线音乐的发展，Bluedio公司致力于使世界各地的消费者拥有精致的音频设备，以更方便地欣赏音乐。",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "返回",
            Off: "",
            Mine: "我的",
            Home: "首页",
            Recommend: "推荐",
            Chang_Lan: "切换语言",
            Unpay_cancle: "未支付订单会在24H后自动删除",
            Old_password: "旧密码",
            Confirm_password: "确认密码",
            Remove: "移除",
            Author: "作者",
            Published_on: "发布于",
            Contact: "咨询",
            Modify_password_success: "修改密码成功",
            Modify_password_failed: "修改密码失败",
            Password_must_the_same: "密码必须相同",
            Region_limit: "当前不支持发货",
            Free_ExpressDelivery: "免运费,发货地:",
            Discount_ends_in: "优惠结束于 ",
            Discount_unit_day: "天 ",
            Following: "Following:",
            Privacy_of_Policy: "使用条款，政策隐私",
            Faq: "常见问题",
            Register_for_Warranty: "注册保修",
            Warranty_Guidelines: "保修指引",
            Shipping_Returens: "运输与退货",
            Instruction_Book: "产品使用说明书",
            Blog: "Blog",
            Gift_Box: "礼物盒",
            Previous: "上一页",
            Next: "下一页",
            Warranty_register_name: "姓名",
            Warranty_register_email: "邮箱",
            Warranty_register_phone: "电话",
            Warranty_register_buyfrom: "从哪里购买",
            Warranty_register_product: "选择产品",
            Warranty_register_Ordernum: "订单号",
            Warranty_register_Serialnum: "序列号",
            Warranty_register_Title: "注册",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "现在注册",
            Fans_discount: "粉丝优惠",
            Download_title: "7.1虚拟声卡驱动",
            Download_desc: "如果不能下载，请将下面网址复制到浏览器打开",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
    en: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    de: {
        message: {
            Categories: "Kategorien",
            Community: "Gemeinschaft",
            Save: "Speichern",
            Register: "Registrieren",
            Sign_Up: "Registrieren",
            Login: "Login",
            UserName: "Benutzername",
            News: "News",
            Service: "Service",
            Memberships: "Mitgliedschaft",
            AllProducts:"Alle Produkte",
            Aboutus: "Über uns",
            Support: "Bereithalten",
            Corporate: "Unternehmen",
            Customized_Service: "Custom Services",
            APP_Download: "APP Herunterladen",
            Instruction_Book: "Kochbuch herunterladen",
            Video: "Video",
            Forum: "Forum",
            Password: "Passwort",
            LOST_PASSWORD: "Ihr Passwort vergessen?",
            Username_Email_Phone: "Benutzername/E-Mail/Telefonnummer",
            Sign_Up_Failed: "Registrierung fehlgeschlagen",
            email: "Mailbox",
            My_Cart: "Mein Warenkorb",
            CART_TOTAL: "Gesamt",
            POST: "Post",
            Company: "Unternehmensinformationen",
            Service_Item: "Serviceartikel",
            Company_Dynamic: "Unternehmensdynamik",
            Talent_Recruitment: "Talent Rekrutierung",
            Cooperation: "Zusammenarbeit",
            After_sale: "After-Sales",
            Product_Verification: "Anti-Fälschungs-Abfrage",
            Read_more: "Mehr",
            Commit: "Einreichen",
            Title: "Themen",
            Please_Enter_Title: "Bitte geben Sie den Titel ein",
            Please_Enter_Topic_Type: "Bitte wählen Sie das Betreff",
            Topic_Type: "Subjektklassifizierung",
            You_need_fill_all_input: "Bitte füllen Sie alle Optionen aus!!",
            Please_Log_In: "Bitte melden Sie sich an",
            The_Comment_Is_Blank: "Kommentare können nicht leer sein!",
            STOCK: "Stock",
            QUANTITY: "Menge",
            ADD_TO_CART: "Warenkorb",
            Product_Description: "Produktbeschreibung",
            COLORS: "Farbe",
            COLOR: "Farbe",
            Load_More: "Mehr laden",
            Insufficient_quantity: "Unzureichende Menge",
            Add_Success: "Erfolg hinzufügen",
            Shopping_Bag: "Einkaufswagen",
            Checkout_Details: "Zahlungsdetails",
            Complete_Order: "Vollständige Zahlung",
            Description: "Produktinformationen	",
            Shipping_Itmes: "Produktinformationen  ",
            Customize_message: "Benutzerdefinierte Informationen	",
            Subtotal: "Kleiner Plan",
            Total: "Gesamt",
            Submit_Order: "Bestellung absenden",
            The_Cart_Empty: "Einkaufswagen ist leer",
            SHOPPING_CART_TOTALS: "Mein Warenkorb",
            Transaction_Record: "Transaktionen",
            My_Order: "Bestellliste",
            Change_Password: "Ändern Sie Ihr Passwort",
            Welcome_you: "Willkommen bei Ihnen",
            Personal_Center: "Persönliches Zentrum",
            Reply: "Antwort",
            Tran_Addr: "Versandadresse",
            Manual: "Bedienungsanleitung",
            Security: "Anti-Fälschung",
            Customize: "Custom",
            Promotions: "Verwandte Werbeaktionen",
            Bluedio_News: "Bluedio news",
            Product_Name: "Produktname",
            Count: "Menge",
            Price: "Preis",
            Unpaid_Order: "Unbezahlt",
            Paid_Order: "Bezahlt",
            Order_Number: "Bestellnummer",
            Order_Date: "Datum",
            Payment_Way: "Zahlungsmethode",
            Total: "Betrag",
            Recruit: "Rekrutierung",
            Order_Status: "Handelsstatus",
            Logout: "Logout",
            Confirm_Psw: "Passwort bestätigen",
            Retrieve_Password: "Passwort abrufen",
            Email_Not_Ass_Usr: "Es wurden keine Benutzer gefunden, die dem Postfach zugeordnet sind.",
            Next_Step: "Weiter",
            Welcome_to_Bluedio_mall: "Bluedio Mall heißt Sie willkommen",
            You_logout: "Du hast dich noch nicht eingeloggt",
            Customize_your_product: "Benutzerdefinierte Ihre eigenen Produkte",
            None: "Zählen Sie es auf",
            Sure: "OK",
            Cancle: "Abbrechen",
            Addr: "Adresse",
            Tel: "Telefonnummer",
            Shipping_address: "Empfangsadresse",
            Success: "Erfolg",
            To_Checkout: "Gehen Sie zur Kasse",
            Billing_Address: "Rechnungsadresse senden",
            Total_Amount: "Gesamtpreis",
            Currency_Code: "Währungscode",
            Your_Contact_Information: "Ihre Kontaktinformationen",
            Telephone_Format: "Telefonnummer",
            Please_Enter_Phone: "Bitte geben Sie Ihre Telefonnummer ein",
            Please_Enter_UsrName: "Bitte geben Sie den Benutzernamen ein",
            Please_Enter_Passward: "Bitte geben Sie Ihr Passwort ein",
            Please_Enter_Passward_Again: "Bitte geben Sie Ihr Passwort erneut ein",
            Please_enter_the_coupon_code: "Bitte geben Sie den Gutscheincode ein",
            Commission_account: "Kommissionsflusseintritt",
            Brokerage: "Kommission",
            Related_Video_Recommendation: "Verwandte Videoempfehlungen",
            All: "Alle",
            Headband: "Kopftragend",
            In_ear: "Ins Ohr",
            Sound: "Sound",
            Others: "Sonstiges",
            Buyer: "Käufer",
            Current_commission: "Aktuelle Kommission",
            Withdraw: "Cash-in",
            Withdraw_time: "Bargeld kann 30 Tage nach Erhalt des Eingangs gemacht werden, ",
            Share_0: "Regeln, um Bluedio Vertriebspartner zu werden:",
            Share_1: "Die Ausgaben auf der Bluedio Website vor dem 1. Juli 2019 werden automatisch auf blue string partner aktualisiert;",
            Share_2: "Nach dem 1. Juli 2019 müssen Sie auf der Bluedio Website für insgesamt 1500 USD einkaufen, um sich als Vertriebspartner zu qualifizieren;",
            Share_3: "Bluedio Vertriebspartner mit meiner Kontonummer auf der offiziellen Website unter der Bestellung ist 20% Rabatt;",
            Share_4: "Bluedio Sales Partner erhält exklusiven digitalen Code im Personal Center",
            Share_5: "Benutzer, die Produkte mit dem exklusiven digitalen Code des Vertriebspartners kaufen, erhalten einen Rabatt von 5 %",
            Share_6: "Der Vertriebspartner, der den digitalen Code bereitstellt, erhält einen Provisionsbonus von 20 %;",
            Share_7: "Vertriebspartner können den Status des Produktkaufs gemäß der Spalte Commission Earn-Redaktion herausfinden;",
            Share_8: "Wenn die Kommission verdient Spalte zeigt, dass Sie die Gegenwart erwähnen können, kontaktieren Sie die Blue String Offiziellen Rückzug;",
            Please_enter_the_email: "Bitte geben Sie Ihr Postfach ein",
            Submit: "Einreichen",
            Psw_Same: "Zwei Passwörter bitte zustimmen",
            Discount_price: "Discounted Price",
            Recommendation_code: "Ihr Empfehlungscode",
            Enter_your_product_code: "Geben Sie Ihren Produktcode ein",
            Add_cart: "In den Warenkorb gelegt",
            Buy_now: "Jetzt kaufen",
            Coupon_now: "Mitgliederangebote",
            Usr_Psw_Erro: "Benutzername oder Kennwortfehler.",
            Not_member: "Sie sind noch kein Vertriebspartner mit blauen Strings.",
            Can_withdraw: "Cashcants",
            Pre_acquisition: "Vor-Rückzug",
            Invalid: "Ungültig",
            Commit_failed: "Senden fehlgeschlagen",
            couponTitle: "Freier Austausch, Kontaktinformationen",
            couponEmail: "Email",
            couponPhone: "Telefon",
            couponCountry: "Land",
            couponContact: "Kontakt",
            couponAddress: "Adresse",
            couponZip: "Postleitzahl",
            Driver_Message: "7.1 Virtuelles Soundkartenlaufwerk",
            Bluedio_Mall: "Bluedio Offizielles Einkaufszentrum",
            Bluedio_Mall_Tagline: "Professioneller Hersteller von Audiogeräten",
            Bluedio_Mall_Keywords: "Bluetooth-Ohrhörer Drahtlose Ohrhörer Geräuschunterdrückung Drahtlose Ohrhörer Ohrhörer für den Sport Wirklich drahtlose Ohrhörer Bluetooth-Headset Gaming-Headset Headset Drahtloses Headset Bluetooth-Lautsprecher Tragbare Lautsprecher Computerlautsprecher Heimkino-Lautsprecher Außenlautsprecher Drahtlose Lautsprecher Laptop-Lautsprecher PC-Lautsprecher Desktop-Lautsprecher",
            Bluedio_Mall_Description: "Bluedio ist ein professionelles Unternehmen für Audiogeräte, das Entwicklung, Herstellung und Marketing kombiniert. Wir sind seit über 20 Jahren auf diesem Gebiet tätig. Bei weitem waren wir in der Lage, Software und Hardware zu entwerfen, Teile herzustellen, ganze Geräte zusammenzubauen und zu vermarkten. Und basierend auf Daten sind wir das schnellste Unternehmen in der gesamten Industriekette, das Produkte unabhängig voneinander entwickelt und produziert. Das Unternehmen Bluedio setzt sich für die Förderung der Entwicklung drahtloser Musik ein und hat sich zum Ziel gesetzt, den Verbrauchern auf der ganzen Welt exquisite Audiogeräte zur Verfügung zu stellen, mit denen sie Musik bequemer genießen können.",
            Bluedio_Worry_Title: "Sorgenfreies Einkaufen",
            Bluedio_Worry_free: "Sorgenfreies Einkaufen: Bluedio bietet 30 Tage Geld zurück und ein Jahr Herstellergarantie auf die Produkte......",
            Back: "Rückkehr",
            Off: "",
            Mine: "Mein",
            Home: "Zuhause",
            Recommend: "Empfohlen",
            Chang_Lan: "Sprache wechseln",
            Unpay_cancle: "Unbezahlte Bestellungen werden nach 24H automatisch gelöscht",
            Old_password: "Altes Passwort",
            Confirm_password: "Passwort bestätigen",
            Remove: "Entfernen",
            Author: "Autor",
            Published_on: "Posted on",
            Contact: "Beratung",
            Modify_password_success: "Erfolgreiche Passwortänderung",
            Modify_password_failed: "Kennwort nicht geändert",
            Password_must_the_same: "Das Kennwort muss identisch sein",
            Region_limit: "Versand wird derzeit nicht unterstützt",
            Free_ExpressDelivery: "Kostenloser Versand,Versand von",
            Discount_ends_in: "Angebot endet um ",
            Discount_unit_day: "Tage ",
            Following: "Folgen:",
            Privacy_of_Policy: "Nutzungsbedingungen, Datenschutzbestimmungen",
            Faq: "FAQ",
            Register_for_Warranty: "Garantie registrieren",
            Warranty_Guidelines: "Garantierichtlinien",
            Shipping_Returens: "Versand & Rückgabe",
            Instruction_Book: "Bedienungsanleitung",
            Blog: "Blog",
            Gift_Box: "Geschenkbox",
            Previous: "Bisherige",
            Next: "Nächster",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Telefon",
            Warranty_register_buyfrom: "Wo hast du gekauft?",
            Warranty_register_product: "Bitte wählen Sie Ihr Produkt aus",
            Warranty_register_Ordernum: "Bestellnummer",
            Warranty_register_Serialnum: "Ordnungsnummer",
            Warranty_register_Title: "Registrieren",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Jetzt registrieren",
            Fans_discount: "Fan-Angebot",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    fr: {
        message: {
            Categories: "Catégories",
            Community: "Communauté ",
            Save: "Enregistrer",
            Register: "Inscrivez-vous",
            Sign_Up: "Inscrivez-vous",
            Login: "Login",
            UserName: "Nom d’utilisateur",
            News: "Nouvelles",
            Service: "Service",
            Memberships: "Adhésion",
            AllProducts:"Tous les produits",
            Aboutus: "Nous",
            Support: "Soutien",
            Corporate: "Entreprise",
            Customized_Service: "Services personnalisés",
            APP_Download: "APP Download",
            Instruction_Book: "Cookbook Télécharger",
            Video: "Vidéo",
            Forum: "Forum",
            Password: "Mot de passe",
            LOST_PASSWORD: "Oublié votre mot de passe?",
            Username_Email_Phone: "Nom d’utilisateur/courriel/numéro de téléphone ",
            Sign_Up_Failed: " L’enregistrement a échoué ",
            email: "Mailbox",
            My_Cart: "Mon panier",
            CART_TOTAL: "Total",
            POST: "POST",
            Company: "Informations sur l’entreprise",
            Service_Item: "Ers d’erit ",
            Company_Dynamic: "Dynamique d’entreprise",
            Talent_Recruitment: "Recrutement de talents",
            Cooperation: "Coopération",
            After_sale: "Après-vente ",
            Product_Verification: "Requête anti-contrefaçon:",
            Read_more: "Plus",
            Commit: "Soumettre",
            Title: "Titre",
            Please_Enter_Title: "S’il vous plaît entrer le titre",
            Please_Enter_Topic_Type: "S’il vous plaît sélectionnez le sujet",
            Topic_Type: "Classification des sujets ",
            You_need_fill_all_input: "S’il vous plaît remplir toutes les options! ",
            Please_Log_In: " S’ll vous plaît, connectez-vous,",
            The_Comment_Is_Blank: "Les commentaires ne peuvent pas être vides !",
            STOCK: "Stock",
            QUANTITY: "Quantité",
            ADD_TO_CART: "Ajouter au panie",
            Product_Description: "Description du produit",
            COLORS: "Couleur",
            COLOR: "Couleur",
            Load_More: "Charger plus",
            Insufficient_quantity: "Quantité insuffisante",
            Add_Success: "Ajouter le succès",
            Shopping_Bag: "Panier d’achat",
            Checkout_Details: "Détails de paiement",
            Complete_Order: " Paiement complet",
            Description: "Nformations sur les produit",
            Shipping_Itmes: "Nformations sur les produit",
            Customize_message: "Informations personnalisées ",
            Subtotal: "Petit plan",
            Total: "Total",
            Submit_Order: "Soumettre l’ordre",
            The_Cart_Empty: "Le panier est vide",
            SHOPPING_CART_TOTALS: "Mon panier",
            Transaction_Record: "Transactions",
            My_Order: "Liste des commandes",
            Change_Password: "Changez votre mot de passe",
            Welcome_you: "Bienvenue à vous",
            Personal_Center: "Centre personnel",
            Reply: "Répondre",
            Tran_Addr: "Adresse d’expédition",
            Manual: "Manuel de l’opérateur",
            Security: "Anti-contrefaçon",
            Customize: "Custom",
            Promotions: "Promotions connexes",
            Bluedio_News: "Bluedio Nouvelles",
            Product_Name: "Nom du produit",
            Count: "Quantité",
            Price: "Prix",
            Unpaid_Order: "Non rémunéré",
            Paid_Order: "Payé",
            Order_Number: "Numéro d’ordre",
            Order_Date: "Date",
            Payment_Way: "Mode de paiement",
            Total: "Montant",
            Recruit: "Recrutement",
            Order_Status: "Statut commercial",
            Logout: "Logout",
            Confirm_Psw: "Confirmer le mot de passe",
            Retrieve_Password: "Récupérer le mot de passe",
            Email_Not_Ass_Usr: "Aucun utilisateur associé à la boîte aux lettres n’a été trouvé. ",
            Next_Step: "Suivant",
            Welcome_to_Bluedio_mall: "Bluedio Mall vous accueille",
            You_logout: "Ous ne vous êtes pas encore connecté",
            Customize_your_product: "Custom vos propres produits",
            None: "Comptez-le",
            Sure: "OK",
            Cancle: "Annuler",
            Addr: "Adresse",
            Tel: "Numéro de téléphone",
            Shipping_address: "Adresse de réception",
            Success: "Succès",
            To_Checkout: "Aller payer",
            Billing_Address: "Envoi d’adresse de facturation",
            Total_Amount: "Total",
            Currency_Code: "Code monétaire",
            Your_Contact_Information: "Vos coordonnées",
            Telephone_Format: "Numéro de téléphone",
            Please_Enter_Phone: "Veuillez entrer votre numéro de téléphone",
            Please_Enter_UsrName: "S’il vous plaît entrez le nom d’utilisateur",
            Please_Enter_Passward: "S’il vous plaît, entrez votre mot de passe",
            Please_Enter_Passward_Again: "S’il vous plaît, saisissez à nouveau votre mot de passe",
            Please_enter_the_coupon_code: "S’il vous plaît entrer le code promo",
            Commission_account: "Entrée de flux de la Commission",
            Brokerage: "Commission",
            Related_Video_Recommendation: "Recommandations vidéo connexes",
            All: "Tous",
            Headband: "Head-wearing",
            In_ear: "Dans l’oreille",
            Sound: "Son",
            Others: "Autre",
            Buyer: "Acheteurs",
            Current_commission: "Esse commission actuell",
            Withdraw: "Cash-in",
            Withdraw_time: " L’argent peut être fait 30 jours après la réception de réception",
            Share_0: "ègles pour devenir partenaire de vente de cordes bleues:",
            Share_1: "Les dépenses sur le site Web de Bluedio avant le 1er juillet 2019 passeront automatiquement au partenaire de chaîne bleue",
            Share_2: "Après le 1er juillet 2019, vous devrez faire des achats sur le site Bluedio pour un total de 1500 yens pour être qualifié de partenaire commercial;",
            Share_3: "Bluedio sales partner with my account number in the official website under the order is 20% discount;",
            Share_4: "Bluedio Sales Partner Obtient un code numérique exclusif dans le Centre Personnel",
            Share_5: "Les utilisateurs achètent des produits en utilisant le code numérique exclusif du partenaire commercial bénéficieront d’une réduction de 5 %;",
            Share_6: "Le partenaire commercial qui fournit le code numérique recevra un bonus de commission de 20 % ;",
            Share_7: "Es partenaires commerciaux peuvent connaître l’état de l’achat du produit selon la colonne d’édition de la Commission Earn",
            Share_8: "Lorsque la commission gagne colonne montre que vous pouvez mentionner le présent, contactez le retrait officiel de la chaîne bleue;",
            Please_enter_the_email: "S’il vous plaît, entrez votre boîte aux lettres",
            Submit: "Soumettre",
            Psw_Same: "Deux mots de passe s’il vous plaît d’accord",
            Discount_price: "Prix réduit",
            Recommendation_code: "Votre code de recommandation",
            Enter_your_product_code: "Entrez votre code produit",
            Add_cart: "Ajouté au panier",
            Buy_now: "Acheter maintenant",
            Coupon_now: " Offres de membre",
            Usr_Psw_Erro: "Erreur de nom d’utilisateur ou de mot de passe .",
            Not_member: "Vous n’êtes pas encore un partenaire de vente de cordes bleues.",
            Can_withdraw: "Cascants",
            Pre_acquisition: "Pré-retrait",
            Invalid: "Invalide",
            Commit_failed: "Soumettre échoué",
            couponTitle: "Échange gratuit, coordonnées",
            couponEmail: "Email",
            couponPhone: "Téléphone",
            couponCountry: "Pays",
            couponContact: "Contact",
            couponAddress: "Adresse",
            couponZip: "ZIP *: FRANÇAIS",
            Driver_Message: "7.1 Virtual Sound Card Drive",
            Bluedio_Mall: "Centre commercial officiel de Bluedio",
            Bluedio_Mall_Tagline: "fabricant de périphérique audio professionnel",
            Bluedio_Mall_Keywords: "Écouteurs Bluetooth Écouteurs sans fil Écouteurs sans fil Écouteurs pour le sport Écouteurs vraiment sans fil Casque Bluetooth Casque de jeu Casque Casque sans fil Haut-parleurs Bluetooth Haut-parleurs portables Haut-parleurs pour ordinateur Haut-parleurs home cinéma Haut-parleurs extérieurs Haut-parleurs sans fil Haut-parleurs pour ordinateur portable Haut-parleurs PC Haut-parleurs de bureau Haut-parleurs de bureau",
            Bluedio_Mall_Description: "Bluedio est une entreprise d'appareils audio professionnels qui allie développement, fabrication et commercialisation, nous avons plus de 20 ans d'expérience dans ce domaine. Nous sommes de loin capables de concevoir, de développer des logiciels et du matériel, de produire des pièces de structure, d'assembler et de commercialiser des appareils entiers. Et sur la base des données, avec un centre d'utilisateurs pour développer en profondeur la capacité de service écologique, nous sommes l'entreprise la plus rapide de toute la chaîne industrielle pour développer et produire des produits de manière indépendante. Engagée à promouvoir le développement de la musique sans fil, la société Bluedio a pour objectif de faire en sorte que les consommateurs du monde entier disposent d'un équipement audio exquis pour profiter de la musique plus facilement.",
            Bluedio_Worry_Title: "Achats sans souci",
            Bluedio_Worry_free: "Achats sans souci: Bluedio offre un remboursement de 30 jours et une garantie du fabricant d'un an sur les produits.....",
            Back: "Retour",
            Off: "",
            Mine: "Mon",
            Home: "Accueil",
            Recommend: "Recommandé",
            Chang_Lan: "Switch language",
            Unpay_cancle: "Les commandes impayées seront automatiquement supprimées après 24H ",
            Old_password: "Vieux mot de passe",
            Confirm_password: "Confirmer le mot de passe",
            Remove: "Supprimer",
            Author: "Auteur",
            Published_on: "Posté sur",
            Contact: "Onsultatio",
            Modify_password_success: "Changement de mot de passe réussi",
            Modify_password_failed: "Échec de changer de mot de passe",
            Password_must_the_same: "Le mot de passe doit être le même",
            Region_limit: "L’expédition n’est pas actuellement prise en charge",
            Free_ExpressDelivery: "livraison gratuite,Expédition de",
            Discount_ends_in: "L'offre se termine à ",
            Discount_unit_day: "jour ",
            Following: "Following:",
            Privacy_of_Policy: "Conditions d'utilisation, politique de confidentialité",
            Faq: "FAQ",
            Register_for_Warranty: "Enregistrer la garantie",
            Warranty_Guidelines: "Consignes de garantie",
            Shipping_Returens: "Expédition & retours",
            Instruction_Book: "Livre d'instructions",
            Blog: "Blog",
            Gift_Box: "Boite cadeau",
            Previous: "Précédent",
            Next: "Prochain",
            Warranty_register_name: "Nom",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Téléphone",
            Warranty_register_buyfrom: "D'où avez-vous acheté",
            Warranty_register_product: "Veuillez sélectionner votre produit",
            Warranty_register_Ordernum: "Numéro de commande",
            Warranty_register_Serialnum: "Numéro de série",
            Warranty_register_Title: "S'inscrire",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "S'inscrire maintenant",
            Fans_discount: "Offre de fan",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    es: {
        message: {
            Categories: "Categorias",
            Community: "Comunidad",
            Save: "Guardar",
            Register: "Registrarse",
            Sign_Up: "Registrarse",
            Login: "Iniciar sesión",
            UserName: "Nombre de usuario",
            News: "Noticias",
            Service: "Servicio",
            Memberships: "Membresías",
            AllProducts:"Todos los productos",
            Aboutus: "Nosotros",
            Support: "Apoyo",
            Corporate: "Empresa",
            Customized_Service: "Servicios personalizados",
            APP_Download: "App Descargar",
            Instruction_Book: "Cookbook Download",
            Video: "Vídeo",
            Forum: "Foro",
            Password: "Contraseña",
            LOST_PASSWORD: "¿Olvidaste tu contraseña?",
            Username_Email_Phone: "Nombre de usuario/correo electrónico/número de teléfono",
            Sign_Up_Failed: "Error de registro",
            email: "Mailbox",
            My_Cart: "Mi carrito de compras",
            CART_TOTAL: "Total",
            POST: "Publicar",
            Company: "Información de la empresa",
            Service_Item: "Artículos de servicio",
            Company_Dynamic: "Dinámica de la empresa",
            Talent_Recruitment: "Reclutamiento de talentos",
            Cooperation: "Cooperación",
            After_sale: "Post-ventas",
            Product_Verification: "Consulta antifalsificación:",
            Read_more: "Más",
            Commit: "Enviar",
            Title: "Título",
            Please_Enter_Title: "Por favor, introduzca el título",
            Please_Enter_Topic_Type: "Por favor, seleccione el tema",
            Topic_Type: "Clasificación de tema",
            You_need_fill_all_input: "Por favor, rellene todas las opciones!!",
            Please_Log_In: "Por favor, inicie sesión",
            The_Comment_Is_Blank: "¡Los comentarios no pueden estar vacíos!",
            STOCK: "Stock",
            QUANTITY: "Cantidad",
            ADD_TO_CART: "Carro de compras",
            Product_Description: "Descripción del producto",
            COLORS: "Color",
            COLOR: "Color",
            Load_More: "Cargar más",
            Insufficient_quantity: "Cantidad insuficiente",
            Add_Success: "Añadir éxito",
            Shopping_Bag: "Cesta de compras",
            Checkout_Details: "Detalles de pago",
            Complete_Order: "Pago completo",
            Description: "Información del producto	",
            Shipping_Itmes: "Información del producto  ",
            Customize_message: "Información personalizada ",
            Subtotal: "Pequeño plan",
            Total: "Total",
            Submit_Order: "Enviar pedido",
            The_Cart_Empty: "El carrito de la compra está vacío",
            SHOPPING_CART_TOTALS: "Mi carrito de compras",
            Transaction_Record: "Transacciones",
            My_Order: "Lista de pedidos",
            Change_Password: "Cambia tu contraseña",
            Welcome_you: "Bienvenido a ti",
            Personal_Center: "Centro personal",
            Reply: "Respuesta",
            Tran_Addr: "Dirección de envío",
            Manual: "Manual del operado",
            Security: "Antifalsificación",
            Customize: "Personalizado",
            Promotions: "Promociones relacionada",
            Bluedio_News: "Noticias de Cuerda Azul",
            Product_Name: "Nombre del producto",
            Count: "Cantidad",
            Price: "Precio",
            Unpaid_Order: "No remunerado",
            Paid_Order: "Pagado",
            Order_Number: "Número de pedido",
            Order_Date: "Fecha",
            Payment_Way: "Método de pago",
            Total: "Cantidad",
            Recruit: "Reclutamiento",
            Order_Status: "Estado comercial",
            Logout: "Logout",
            Confirm_Psw: "Confirmar contraseña",
            Retrieve_Password: "Recuperar contraseña",
            Email_Not_Ass_Usr: "No se encontraron usuarios asociados con el buzón.",
            Next_Step: "Siguiente",
            Welcome_to_Bluedio_mall: "Bluedio Mall le da la bienvenida",
            You_logout: "Aún no has iniciado sesión",
            Customize_your_product: "Personaliza tus propios productos",
            None: "Contarlo",
            Sure: "Bien",
            Cancle: "Cancelar",
            Addr: "Dirección",
            Tel: "Teléfono",
            Shipping_address: "Dirección de recepción",
            Success: "Éxito",
            To_Checkout: "Ir a pagar",
            Billing_Address: "Enviar dirección de facturación",
            Total_Amount: "Total",
            Currency_Code: "Código de moneda",
            Your_Contact_Information: "Su información de contacto",
            Telephone_Format: "Teléfono",
            Please_Enter_Phone: "Por favor, introduzca su número de teléfono",
            Please_Enter_UsrName: "Por favor, introduzca el nombre de usuario",
            Please_Enter_Passward: "Introduzca su contraseña",
            Please_Enter_Passward_Again: "Por favor, introduzca su contraseña de nuevo",
            Please_enter_the_coupon_code: "Introduzca el código de cupón",
            Commission_account: "Entrada de flujo de comisión",
            Brokerage: "Comisión",
            Related_Video_Recommendation: "Recomendaciones de vídeo relacionadas",
            All: "Muy buen",
            Headband: "Head-wearing",
            In_ear: "En el oído",
            Sound: "Sonido",
            Others: "Muy",
            Buyer: "Compradores",
            Current_commission: "Comisión actual",
            Withdraw: "Cash-in",
            Withdraw_time: "El efectivo puede ser con hecho 30 días después de la recepción de la recepción",
            Share_0: "Reglas para convertirse en socio de ventas de cadena azul:",
            Share_1: "El gasto en el sitio web de Bluedio antes del 1 de julio de 2019 se actualizará automáticamente a socio de cadena azul;",
            Share_2: "Después del 1 de julio de 2019, tendrá que comprar en el sitio web de Blue String un total de 1500 libras esterlinas para calificar como socio de ventas;",
            Share_3: "El socio de ventas de cadena azul con mi número de cuenta en el sitio web oficial bajo el pedido es 20% de descuento;",
            Share_4: "El socio de ventas de Blue String obtiene código digital exclusivo en el centro personal",
            Share_5: "Los usuarios que compren productos utilizando el código digital exclusivo del socio comercial recibirán un 5% de descuento;",
            Share_6: "El socio de ventas que proporcione el código digital recibirá un bono de comisión del 20%;",
            Share_7: "Los socios de ventas pueden averiguar el estado de la compra del producto de acuerdo con la columna de edición Commission Earn;",
            Share_8: "Cuando la comisión gana la columna muestra que puede mencionar el presente, póngase en contacto con el Retiro Oficial de Bluedio;",
            Please_enter_the_email: "Por favor, introduzca su buzón de correo",
            Submit: "Enviar",
            Psw_Same: "Dos contraseñas por favor, de acuerdo",
            Discount_price: "Precio con descuento",
            Recommendation_code: "Su código de recomendació",
            Enter_your_product_code: "Introduzca su código de producto",
            Add_cart: "Añadido al carro de la compra",
            Buy_now: "Comprar ahora",
            Coupon_now: "Ofertas para miembros",
            Usr_Psw_Erro: "Error de nombre de usuario o contraseña.",
            Not_member: "Todavía no eres un socio de ventas de cuerda azul.",
            Can_withdraw: "Cashcants",
            Pre_acquisition: "Pre-retirada",
            Invalid: "No válido",
            Commit_failed: "Error al enviar",
            couponTitle: "Intercambio gratuito, información de contacto",
            couponEmail: "Email",
            couponPhone: "Teléfono",
            couponCountry: "País",
            couponContact: "Contacto",
            couponAddress: "Habla a",
            couponZip: "CÓDIGO POSTAL",
            Driver_Message: "7.1 Unidad de tarjeta de sonido virtual",
            Bluedio_Mall: "Centro comercial Bluedio",
            Bluedio_Mall_Tagline: "Fabricante profesional de dispositivos de audio",
            Bluedio_Mall_Keywords: "Auriculares Bluetooth Auriculares inalámbricos Cancelación de ruido Auriculares inalámbricos Auriculares para deporte Auriculares verdaderamente inalámbricos Auriculares Bluetooth Auriculares para juegos Auriculares Auriculares inalámbricos altavoces bluetooth Altavoces portátiles Altavoces para computadora Altavoces para cine en casa Altavoces para exteriores Altavoces portátiles Altavoces para PC Altavoces para PC Altavoces para PC",
            Bluedio_Mall_Description: "Bluedio es una empresa profesional de dispositivos de audio que combina el desarrollo, la fabricación y el marketing, tenemos más de 20 años en este campo. Con mucho, hemos sido capaces de diseñar, desarrollar software y hardware, producir piezas de estructura, ensamblar todo el dispositivo y comercializarlo. Y en base a los datos, con el centro de usuarios juntos para desarrollar la capacidad del servicio ecológico en profundidad, somos la empresa más rápida en toda la cadena de la industria en desarrollar y producir productos de forma independiente. Comprometida a promover el desarrollo de la música inalámbrica, la compañía Bluedio tiene el objetivo de hacer que los consumidores de todo el mundo tengan equipos de audio exquisitos para disfrutar de la música de manera más conveniente.",
            Bluedio_Worry_Title: "Compras sin preocupaciones",
            Bluedio_Worry_free: "Compras sin preocupaciones: Bluedio ofrece 30 días de devolución de dinero y un año de garantía del fabricante para los productos......",
            Back: "Regreso",
            Off: "",
            Mine: "Mi",
            Home: "Inicio",
            Recommend: "Recomendable",
            Chang_Lan: "Cambiar idioma",
            Unpay_cancle: "Los pedidos no pagados se eliminarán automáticamente después de 24H",
            Old_password: "Contraseña antigua",
            Confirm_password: "Confirmar contraseña",
            Remove: "Retirar",
            Author: "Autor",
            Published_on: "Publicado en",
            Contact: "Consulta",
            Modify_password_success: "Cambio de contraseña exitoso",
            Modify_password_failed: "No se pudo cambiar la contraseña",
            Password_must_the_same: "La contraseña debe ser la misma",
            Region_limit: "El envío no es compatible actualmente",
            Free_ExpressDelivery: "Envío gratis,Envío desde",
            Discount_ends_in: "La oferta termina a las ",
            Discount_unit_day: "día ",
            Following: "Following:",
            Privacy_of_Policy: "Términos de uso, política de privacidad",
            Faq: "Preguntas más frecuentes",
            Register_for_Warranty: "Registrar garantía",
            Warranty_Guidelines: "Pautas de garantía",
            Shipping_Returens: "Envío y devoluciones",
            Instruction_Book: "Libro de instrucciones",
            Blog: "Blog",
            Gift_Box: "Caja de regalo",
            Previous: "Previo",
            Next: "Próximo",
            Warranty_register_name: "Nombre",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Teléfono",
            Warranty_register_buyfrom: "¿Dónde compraste?",
            Warranty_register_product: "Por favor seleccione su producto",
            Warranty_register_Ordernum: "Número de orden",
            Warranty_register_Serialnum: "Número de serie",
            Warranty_register_Title: "Registrarse",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Regístrate ahora",
            Fans_discount: "Oferta de fan",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    it: {
        message: {
            Categories: "Categorie",
            Community: "Comunità",
            Save: "Salva",
            Register: "Registrati",
            Sign_Up: "Registrati",
            Login: "Login",
            UserName: "Nome utente",
            News: "Notizie",
            Service: "Servizio",
            Memberships: "Adesioni",
            AllProducts:"Tutti i prodotti",
            Aboutus: "Noi",
            Support: "Supporto",
            Corporate: "Aziendale",
            Customized_Service: "Servizi personalizzati",
            APP_Download: "App Scarica",
            Instruction_Book: "Cookbook Download",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "Hai dimenticato la password?",
            Username_Email_Phone: "Nome utente/e-mail/numero di telefono",
            Sign_Up_Failed: "Registrazione non riuscita",
            email: "Email",
            My_Cart: "Il mio carrello della spesa",
            CART_TOTAL: "Totale",
            POST: "Post",
            Company: "Informazioni sull'azienda",
            Service_Item: "Articoli in assistenza",
            Company_Dynamic: "Dinamiche aziendali",
            Talent_Recruitment: "Assunzione dei talenti",
            Cooperation: "Cooperazione",
            After_sale: "Post-vendita",
            Product_Verification: "Interrogazione anticontraffazione:",
            Read_more: "Altro",
            Commit: "Invia",
            Title: "Temi",
            Please_Enter_Title: "Inserisci il titolo",
            Please_Enter_Topic_Type: "Selezionare il soggetto",
            Topic_Type: "Classificazione soggetto",
            You_need_fill_all_input: "Si prega di compilare tutte le opzioni !! ",
            Please_Log_In: "Accedi per favore",
            The_Comment_Is_Blank: "I commenti non possono essere vuoti!",
            STOCK: "Magazzino",
            QUANTITY: "Quantità",
            ADD_TO_CART: "Aggiungi al carrello",
            Product_Description: "Descrizione prodotto",
            COLORS: "Colore",
            COLOR: "Colore",
            Load_More: "Carica di più",
            Insufficient_quantity: "Quantità insufficiente",
            Add_Success: "Aggiungi successo",
            Shopping_Bag: "Carrello della spesa",
            Checkout_Details: "Dettagli pagamento",
            Complete_Order: "Completa pagamento",
            Description: "Informazioni sul prodotto	",
            Shipping_Itmes: "Informazioni sul prodotto  ",
            Customize_message: "Informazioni personalizzate	",
            Subtotal: "Piccolo piano",
            Total: "Totale",
            Submit_Order: "Invia ordine",
            The_Cart_Empty: "Il carrello è vuoto",
            SHOPPING_CART_TOTALS: "Il mio carrello della spesa",
            Transaction_Record: "Transazioni",
            My_Order: "Elenco ordini",
            Change_Password: "Cambia la tua password",
            Welcome_you: "Benvenuto da te",
            Personal_Center: "Centro personale",
            Reply: "Rispondi",
            Tran_Addr: "Indirizzo di spedizione",
            Manual: "Manuale dell'operatore",
            Security: "Anticontraffazione",
            Customize: "Personalizzato",
            Promotions: "Promozioni correlate",
            Bluedio_News: "Bluedio news",
            Product_Name: "Nome prodotto",
            Count: "Quantità",
            Price: "Prezzo",
            Unpaid_Order: "Non retribuito",
            Paid_Order: "Pagato",
            Order_Number: "Numero ordine",
            Order_Date: "Data",
            Payment_Way: "Metodo di pagamento",
            Total: "Importo",
            Recruit: "Reclutamento",
            Order_Status: "Stato di trading",
            Logout: "Logout",
            Confirm_Psw: "Conferma password",
            Retrieve_Password: "Recupera password",
            Email_Not_Ass_Usr: "Non sono stati trovati utenti associati alla cassetta postale.",
            Next_Step: "Avanti",
            Welcome_to_Bluedio_mall: "Bluedio Mall ti dà il benvenuto",
            You_logout: "Non hai ancora effettuato l'accesso",
            Customize_your_product: "Personalizza i tuoi prodotti",
            None: "Contalo",
            Sure: "OK",
            Cancle: "Annulla",
            Addr: "Indirizzo",
            Tel: "Telefono",
            Shipping_address: "Indirizzo di ricezione",
            Success: "Successo",
            To_Checkout: "Vai a pagare",
            Billing_Address: "Invio dell'indirizzo di fatturazione",
            Total_Amount: "Prezzo totale",
            Currency_Code: "Codice valuta",
            Your_Contact_Information: "Le tue informazioni di contatto",
            Telephone_Format: "Telefono",
            Please_Enter_Phone: "Inserisci il tuo numero di telefono",
            Please_Enter_UsrName: "Inserire il nome utente",
            Please_Enter_Passward: "Inserisci la password",
            Please_Enter_Passward_Again: "Inserisci di nuovo la password",
            Please_enter_the_coupon_code: "Inserire il codice coupon",
            Commission_account: "Ingresso del flusso della Commissione",
            Brokerage: "Commissione",
            Related_Video_Recommendation: "Raccomandazioni video correlat",
            All: "Tutti",
            Headband: "Testa-indossare",
            In_ear: "Nell'orecchio",
            Sound: "Suono",
            Others: "Altro",
            Buyer: "Acquirenti",
            Current_commission: "Commissione attuale",
            Withdraw: "Cash-in",
            Withdraw_time: "Cash può essere confatto 30 giorni dopo la ricezione del ricevimento",
            Share_0: "Regole per diventare partner di vendita stringa blu:",
            Share_1: "La spesa sul sito Web Bluedio prima del 1 luglio 2019 verrà automaticamente aggiornata a blue string partner:",
            Share_2: "Dopo il 1 luglio 2019, dovrai fare acquisti sul sito Web Blue String per un totale di 1500 dollari per qualificarti come partner di vendita;",
            Share_3: "Bluedio a partner di vendita con il mio numero di conto nel sito ufficiale sotto l'ordine è 20% sconto;",
            Share_4: "Bluedio Sales Partner ottiene codice digitale esclusivo nel Personal Center",
            Share_5: "Gli utenti che acquistano prodotti utilizzando il codice digitale esclusivo del partner di vendita riceveranno uno sconto del 5%",
            Share_6: "Il partner di vendita che fornisce il codice digitale riceverà un bonus di commissione del 20%;",
            Share_7: "I partner di vendita possono scoprire lo stato dell'acquisto del prodotto in base alla colonna di modifica della Commissione Earn;",
            Share_8: "Quando la commissione guadagna colonna mostra che si può citare il presente, contattare il Bluedio Official Withdrawal;",
            Please_enter_the_email: "Inserisci la tua casella di email",
            Submit: "Invia",
            Psw_Same: "Due password sono d'accordo",
            Discount_price: "Prezzo scontato",
            Recommendation_code: "Il tuo codice di raccomandazione",
            Enter_your_product_code: "Inserire il codice prodotto",
            Add_cart: "Aggiunto al carrello della spesa",
            Buy_now: "Acquista ora",
            Coupon_now: "Offerte per i membri",
            Usr_Psw_Erro: "Errore nome utente o password.",
            Not_member: "Non sei ancora un partner di vendita Bluedio.",
            Can_withdraw: "Cashcants",
            Pre_acquisition: "Pre-ritiro",
            Invalid: "Non valido",
            Commit_failed: "Invio non riuscito",
            couponTitle: "Scambio gratuito, informazioni di contatto",
            couponEmail: "Email",
            couponPhone: "Telefono",
            couponCountry: "Nazione",
            couponContact: "Contatto",
            couponAddress: "Indirizzo",
            couponZip: "Cerniera lampo",
            Driver_Message: "7.1 Virtual Sound Card Drive",
            Bluedio_Mall: "Negozio ufficiale Bluedio",
            Bluedio_Mall_Tagline: "Produttore professionale di dispositivi audio",
            Bluedio_Mall_Keywords: "Auricolari Bluetooth Auricolari wireless Eliminazione del rumore Auricolari wireless Auricolari per lo sport Auricolari veramente wireless Auricolare Bluetooth Cuffie da gioco Cuffie Cuffie wireless Altoparlanti bluetooth Altoparlanti portatili Altoparlanti per PC Altoparlanti home theater Altoparlanti per esterni Altoparlanti wireless Altoparlanti per PC Altoparlanti per PC Altoparlanti per desktop",
            Bluedio_Mall_Description: "Bluedio è una società di dispositivi audio professionali che unisce sviluppo, produzione e marketing, da oltre 20 anni in questo campo. Di gran lunga siamo stati in grado di progettare, sviluppare software e hardware, produrre componenti strutturali, assemblare e commercializzare interi dispositivi. E sulla base dei dati, con il centro utenti insieme per sviluppare profondamente le capacità di servizio ecologico, siamo la società più veloce dell'intera catena del settore a sviluppare e produrre prodotti in modo indipendente. Impegnata a promuovere lo sviluppo della musica wireless, la società Bluedio si prefigge l'obiettivo di rendere i consumatori di tutto il mondo dotati di apparecchiature audio squisite per godersi la musica in modo più conveniente.",
            Bluedio_Worry_Title: "Shopping senza preoccupazioni",
            Bluedio_Worry_free: "Shopping senza preoccupazioni: Bluedio fornisce rimborso entro 30 giorni e un anno di garanzia del produttore sui prodotti......",
            Back: "Ritorna",
            Off: "",
            Mine: "Mio",
            Home: "Casa",
            Recommend: "Consigliato",
            Chang_Lan: "Cambia lingua",
            Unpay_cancle: "Gli ordini non pagati verranno eliminati automaticamente dopo la 24orine",
            Old_password: "Vecchia password",
            Confirm_password: "Conferma password",
            Remove: "Rimuovi",
            Author: "Autore",
            Published_on: "Pubblicato il",
            Contact: "Consulenza",
            Modify_password_success: "Modifica della password riuscita",
            Modify_password_failed: "Impossibile modificare la password",
            Password_must_the_same: "La password deve essere la stessa",
            Region_limit: "La spedizione non è attualmente supportata",
            Free_ExpressDelivery: "Spedizione gratuita,Spedizione da",
            Discount_ends_in: "L'offerta termina a ",
            Discount_unit_day: "giorno ",
            Following: "Following:",
            Privacy_of_Policy: "Condizioni d'uso, politica sulla privacy",
            Faq: "FAQ",
            Register_for_Warranty: "Registra la garanzia",
            Warranty_Guidelines: "Linee guida sulla garanzia",
            Shipping_Returens: "Spedizione e resi",
            Instruction_Book: "Libretto di istruzioni",
            Blog: "Blog",
            Gift_Box: "Pacco regalo",
            Previous: "Precedente",
            Next: "Il prossimo",
            Warranty_register_name: "Nome",
            Warranty_register_email: "E-mail",
            Warranty_register_phone: "Telefono",
            Warranty_register_buyfrom: "Da dove hai comprato",
            Warranty_register_product: "Seleziona il tuo prodotto",
            Warranty_register_Ordernum: "Numero d'ordine",
            Warranty_register_Serialnum: "Numero di serie",
            Warranty_register_Title: "Registrati",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Iscriviti ora",
            Fans_discount: "Offerta dei fan",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    ru: {
        message: {
            Categories: "категории",
            Community: "Сообщество",
            Save: "Сохранить",
            Register: "Регистрация",
            Sign_Up: "Регистрация",
            Login: "Логин",
            UserName: "Имя пользователя",
            News: "Новости",
            Service: "Сервис",
            Memberships: "Членство",
            AllProducts:"Все продукты",
            Aboutus: "насчет нас",
            Support: "Служба поддержки",
            Corporate: "предприятие",
            Customized_Service: "Таможенные услуги",
            APP_Download: "APP Download",
            Instruction_Book: "Cookbook Скачать",
            Video: "Видео",
            Forum: "Форум",
            Password: "Пароль",
            LOST_PASSWORD: "Забыли свой пароль?",
            Username_Email_Phone: "Имя пользователя/электронная почта/номер телефона",
            Sign_Up_Failed: "Регистрация не удалось",
            email: "Почтовый ящик",
            My_Cart: "Моя корзина",
            CART_TOTAL: "Всего",
            POST: "Почта",
            Company: "Информация о компании",
            Service_Item: "Предметы обслуживания",
            Company_Dynamic: "Динамика компании",
            Talent_Recruitment: "Набор талантов",
            Cooperation: "Сотрудничество",
            After_sale: "После продажи",
            Product_Verification: "Анти-контрафактный запрос:",
            Read_more: "Больше",
            Commit: "Отправить",
            Title: "Темы",
            Please_Enter_Title: "Пожалуйста, введите название",
            Please_Enter_Topic_Type: "Пожалуйста, выберите тему",
            Topic_Type: "Субъект классификация",
            You_need_fill_all_input: "Пожалуйста, заполните все варианты!",
            Please_Log_In: "Пожалуйста, войдите в систему",
            The_Comment_Is_Blank: "Комментарии не могут быть пустыми!",
            STOCK: "Сток",
            QUANTITY: "Количество",
            ADD_TO_CART: "Добавить в корзину",
            Product_Description: "Описание продукта",
            COLORS: "Цвет",
            COLOR: "Цвет",
            Load_More: "Загрузить больше",
            Insufficient_quantity: "Недостаточное количество",
            Add_Success: "Добавить успех",
            Shopping_Bag: "Торговая корзина",
            Checkout_Details: "Платежные реквизиты",
            Complete_Order: "Полный платеж",
            Description: "Информация о продукте	",
            Shipping_Itmes: "Информация о продукте  ",
            Customize_message: "Таможенная информация	",
            Subtotal: "Маленький план",
            Total: "общее количество",
            Submit_Order: "Отправить заказ",
            The_Cart_Empty: "Корзина пустых",
            SHOPPING_CART_TOTALS: "Моя корзина",
            Transaction_Record: "Сделки",
            My_Order: "Список заказов",
            Change_Password: "Измените свой пароль",
            Welcome_you: "Добро пожаловать в вас",
            Personal_Center: "Личный центр",
            Reply: "Ответ",
            Tran_Addr: "Доставка адрес",
            Manual: "Руководство оператора",
            Security: "Антифасифия",
            Customize: "Таможня",
            Promotions: "Связанные Акции",
            Bluedio_News: "Новости",
            Product_Name: "Название продукта",
            Count: "Количество",
            Price: "Цена",
            Unpaid_Order: "Неоплаченный",
            Paid_Order: "Платный",
            Order_Number: "Номер заказа",
            Order_Date: "Дата",
            Payment_Way: "Способ оплаты",
            Total: "Сумма",
            Recruit: "Вербовка",
            Order_Status: "Торговый статус",
            Logout: "Пост",
            Confirm_Psw: "Подтвердить пароль",
            Retrieve_Password: "Получить пароль",
            Email_Not_Ass_Usr: "Никаких пользователей, связанных с почтовым ящиком, не было найдено.",
            Next_Step: "Следующий",
            Welcome_to_Bluedio_mall: "Bluedio Mall приветствует вас",
            You_logout: "Вы еще не вошли в систему",
            Customize_your_product: "Настраивайте свои собственные продукты",
            None: "Граф",
            Sure: "Хорошо",
            Cancle: "Отмена",
            Addr: "Адрес",
            Tel: "номер телефона",
            Shipping_address: "Прием адрес",
            Success: "Успех",
            To_Checkout: "Идите, чтобы заплатить",
            Billing_Address: "Отправка адрес биллинга",
            Total_Amount: "Общая цена",
            Currency_Code: "Валютный код",
            Your_Contact_Information: "Ваша контактная информация",
            Telephone_Format: "Номер телефона",
            Please_Enter_Phone: "Пожалуйста, введите свой номер телефона",
            Please_Enter_UsrName: "Пожалуйста, введите имя пользователя",
            Please_Enter_Passward: "Пожалуйста, введите свой пароль",
            Please_Enter_Passward_Again: "Пожалуйста, введите пароль еще раз",
            Please_enter_the_coupon_code: "Пожалуйста, введите код купона",
            Commission_account: "Комиссионный поток вход",
            Brokerage: "Комиссия",
            Related_Video_Recommendation: "Соответствующие видео Рекомендации荐",
            All: "Все",
            Headband: "Голова-ноя",
            In_ear: "В ухо",
            Sound: "Звук",
            Others: "Другое",
            Buyer: "Покупатели",
            Current_commission: "Текущая комиссия",
            Withdraw: "Наличные деньги",
            Withdraw_time: "Наличные могут быть сделано 30 дней после получения квитанции",
            Share_0: "Правила, чтобы стать партнером по продажам синей строки:",
            Share_1: "Расходы на веб-сайте Bluedio до 1 июля 2019 года автоматически перейдут на синее струнное партнера;",
            Share_2: "После 1 июля 2019 года, вам нужно будет делать покупки на веб-сайте Bluedio в общей сложности 1500 фунтов стерлингов, чтобы квалифицироваться в качестве партнера по продажам",
            Share_3: "Партнер по продажам синей строки с моим номером счета на официальном сайте по заказу - скидка 20%;",
            Share_4: "Bluedio Sales Partner получает эксклюзивный цифровой код в личном центре",
            Share_5: "Пользователи, приобретаемые продукты с использованием эксклюзивного цифрового кода торгового партнера, получат скидку 5%",
            Share_6: "Торговый партнер, предоставляющий цифровой код, получит 20% комиссионный бонус;",
            Share_7: "Партнеры по продажам могут узнать статус покупки продукта в соответствии с колонкой редактирования Commission Earn;",
            Share_8: "Когда комиссия зарабатывает колонку показывает, что вы можете упомянуть настоящее, свяжитесь с Bluedio Официальный вывод;",
            Please_enter_the_email: "Пожалуйста, введите свой почтовый ящик",
            Submit: "Отправить",
            Psw_Same: "Два пароля, пожалуйста, соглашайтесь",
            Discount_price: "Дисконтная цена",
            Recommendation_code: "Ваш рекомендательный код",
            Enter_your_product_code: "Введите код продукта",
            Add_cart: "Добавлено в корзину",
            Buy_now: "Купить сейчас",
            Coupon_now: "Предложения участников",
            Usr_Psw_Erro: "Имя пользователя или ошибка пароля.",
            Not_member: "Вы еще не синий партнер по продажам строки.",
            Can_withdraw: "Кашканты",
            Pre_acquisition: "Предварительный вывод",
            Invalid: "Инвалид",
            Commit_failed: "Отправить не удалось",
            couponTitle: "Бесплатный обмен, контактная информация",
            couponEmail: "Эл. адрес",
            couponPhone: "Телефон",
            couponCountry: "Страна",
            couponContact: "контакт",
            couponAddress: "Адрес",
            couponZip: "ZIP",
            Driver_Message: "7.1 Виртуальный звуковой карточный привод",
            Bluedio_Mall: "Bluedio Торговый центр",
            Bluedio_Mall_Tagline: "Профессиональный производитель аудиоустройств",
            Bluedio_Mall_Keywords: "Bluetooth-наушники Беспроводные наушники Беспроводные наушники с шумоподавлением Беспроводные наушники Спортивные наушники Truely Bluetooth-гарнитура Игровая гарнитура Гарнитура Беспроводная гарнитура Bluetooth-колонки Портативные колонки Колонки для компьютера Колонки для домашнего кинотеатра Колонки для улицы Домашние колонки Колонки для улицы наружные Колонки для дома Беспроводные колонки Колонки для ноутбука Колонки для ПК Колонки для настольных ПК",
            Bluedio_Mall_Description: "Bluedio - это профессиональная компания по производству аудиоустройств, которая объединяет разработку, производство и маркетинг. Мы работаем в этой области более 20 лет. На сегодняшний день мы способны проектировать, разрабатывать программное и аппаратное обеспечение, производить конструкционные детали, собирать и продавать все устройства. И, основываясь на данных, вместе с центром пользователя для глубокого развития экологических услуг, мы являемся самой быстрой компанией во всей цепочке промышленности, которая самостоятельно разрабатывает и производит продукцию. Стремясь содействовать развитию беспроводной музыки, компания Bluedio стремится предоставить потребителям во всем мире изысканное звуковое оборудование для более удобного прослушивания музыки.",
            Bluedio_Worry_Title: "Беззаботная покупка",
            Bluedio_Worry_free: "Покупки без лишних хлопот: Bluedio предоставляет 30-дневный возврат денег и один год гарантии производителя на продукты......",
            Back: "Возвращение",
            Off: "",
            Mine: "Мой",
            Home: "Домашний",
            Recommend: "Рекомендуем",
            Chang_Lan: "Язык коммутатора",
            Unpay_cancle: "Неоплаченные заказы будут автоматически удалены после 24H",
            Old_password: "Старый пароль",
            Confirm_password: "Подтвердить пароль",
            Remove: "Удалить",
            Author: "Автор",
            Published_on: "Опубликовано на",
            Contact: "Консультации",
            Modify_password_success: "Успешное изменение пароля",
            Modify_password_failed: "Не удалось изменить пароль",
            Password_must_the_same: "Пароль должен быть одинаковым",
            Region_limit: "Доставка в настоящее время не поддерживается",
            Free_ExpressDelivery: "бесплатная доставка,Доставка из",
            Discount_ends_in: "Предложение заканчивается в ",
            Discount_unit_day: "день ",
            Following: "Следующий:",
            Privacy_of_Policy: "Условия использования, политика конфиденциальности",
            Faq: "Вопросы-Ответы",
            Register_for_Warranty: "Зарегистрировать гарантию",
            Warranty_Guidelines: "Руководство по гарантии",
            Shipping_Returens: "Доставка и возврат",
            Instruction_Book: "Инструкция",
            Blog: "Блог",
            Gift_Box: "Подарочная коробка",
            Previous: "предыдущий",
            Next: "следующий",
            Warranty_register_name: "название",
            Warranty_register_email: "Эл. адрес",
            Warranty_register_phone: "Телефон",
            Warranty_register_buyfrom: "Где вы купили у",
            Warranty_register_product: "Пожалуйста, выберите ваш продукт",
            Warranty_register_Ordernum: "Порядковый номер",
            Warranty_register_Serialnum: "Серийный номер",
            Warranty_register_Title: "регистр",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Зарегистрируйтесь сейчас",
            Fans_discount: "Предложение фанатов",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    tr: {
        message: {
            Categories: "Kategoriler",
            Community: "Topluluk",
            Save: "Kaydet",
            Register: "Kayıt Ol",
            Sign_Up: "Kayıt Ol",
            Login: "Giriş",
            UserName: "Kullanıcı adı",
            News: "Haberler",
            Service: "Hizmet",
            Memberships: "Üyelikler",
            AllProducts:"Tüm ürünler",
            Aboutus: "Biz",
            Support: "Destek",
            Corporate: "Kurumsal",
            Customized_Service: "Özel Hizmetler",
            APP_Download: "APP İndir",
            Instruction_Book: "Yemek Kitabı İndir",
            Video: "Video",
            Forum: "Forum",
            Password: "Şifre",
            LOST_PASSWORD: "Şifreni mi unuttun?",
            Username_Email_Phone: "Kullanıcı adı/e-posta/telefon numarası",
            Sign_Up_Failed: "Kayıt başarısız oldu",
            email: "E-posta",
            My_Cart: "Alışveriş Sepetim",
            CART_TOTAL: "Toplam",
            POST: "Posta",
            Company: "Şirket Bilgileri",
            Service_Item: "Servis Öğeleri",
            Company_Dynamic: "Şirket Dinamikleri",
            Talent_Recruitment: "Yetenek Alımı",
            Cooperation: "İşbirliği",
            After_sale: "Satış sonrası",
            Product_Verification: "Sahteciliği önleme sorgusu:",
            Read_more: "Daha fazla",
            Commit: "Gönder",
            Title: "Temalar",
            Please_Enter_Title: "Lütfen başlığı girin",
            Please_Enter_Topic_Type: "Lütfen konuyu seçiniz",
            Topic_Type: "Konu sınıflandırması",
            You_need_fill_all_input: "Lütfen tüm seçenekleri doldurun!",
            Please_Log_In: "Lütfen giriş yapın",
            The_Comment_Is_Blank: "Yorumlar boş olamaz!",
            STOCK: "Hisse Senedi",
            QUANTITY: "Miktar",
            ADD_TO_CART: "Alışveriş sepetine ekle",
            Product_Description: "Ürün Açıklaması",
            COLORS: "Renk",
            COLOR: "Renk",
            Load_More: "Daha fazla yükleyin",
            Insufficient_quantity: "Yetersiz miktar",
            Add_Success: "Başarı Ekle",
            Shopping_Bag: "Alışveriş Sepeti",
            Checkout_Details: "Ödeme detayları",
            Complete_Order: "Tam ödeme",
            Description: "Ürün Bilgileri",
            Shipping_Itmes: "Ürün Bilgileri ",
            Customize_message: "Özel Bilgi",
            Subtotal: "Küçük plan",
            Total: "Toplam",
            Submit_Order: "Sipariş gönder",
            The_Cart_Empty: "Alışveriş sepeti boş",
            SHOPPING_CART_TOTALS: "Alışveriş Sepetim",
            Transaction_Record: "İşlemler",
            My_Order: "Sipariş Listesi",
            Change_Password: "Şifreni değiştir",
            Welcome_you: "Hoş geldiniz",
            Personal_Center: "Kişisel Merkez",
            Reply: "Yanıtla",
            Tran_Addr: "Sevkiyat adresi",
            Manual: "Operatör El Kitabı",
            Security: "Sahteciliği önleme",
            Customize: "Özel",
            Promotions: "İlgili Promosyonlar",
            Bluedio_News: "Bluedio Haberler",
            Product_Name: "Ürün adı",
            Count: "Miktar",
            Price: "Fiyat",
            Unpaid_Order: "Ödenmemiş",
            Paid_Order: "Ücretli",
            Order_Number: "Sipariş Numarası",
            Order_Date: "Tarih",
            Payment_Way: "Ödeme yöntemi",
            Total: "Tutar",
            Recruit: "İşe alım",
            Order_Status: "Ticaret durumu",
            Logout: "Posta",
            Confirm_Psw: "Parolayı onayla",
            Retrieve_Password: "Parola al",
            Email_Not_Ass_Usr: "Posta kutusuyla ilişkili kullanıcı bulunamadı.",
            Next_Step: "Sıradaki",
            Welcome_to_Bluedio_mall: "Bluedio Alışveriş Merkezi Sizi Karşılıyor",
            You_logout: "Henüz giriş yapmadın.",
            Customize_your_product: "Kendi ürünlerinizi özelleştirin",
            None: "Say",
            Sure: "Tamam",
            Cancle: "İptal Et",
            Addr: "Adres",
            Tel: "Telefon",
            Shipping_address: "Adres alma",
            Success: "Başarı",
            To_Checkout: "Ödemeye git",
            Billing_Address: "Fatura adresi gönderme",
            Total_Amount: "Toplam fiyat",
            Currency_Code: "Para Kodu",
            Your_Contact_Information: "İletişim bilgileriniz",
            Telephone_Format: "Telefon",
            Please_Enter_Phone: "Lütfen telefon numaranızı giriniz",
            Please_Enter_UsrName: "Lütfen kullanıcı adını girin",
            Please_Enter_Passward: "Lütfen şifrenizi giriniz",
            Please_Enter_Passward_Again: "Lütfen şifrenizi tekrar giriniz",
            Please_enter_the_coupon_code: "Lütfen kupon kodunu girin",
            Commission_account: "Komisyon akış girişi",
            Brokerage: "Komisyon",
            Related_Video_Recommendation: "İlgili Video Önerileri",
            All: "Tümü",
            Headband: "Kafa giydirme",
            In_ear: "Kulağa",
            Sound: "Ses",
            Others: "Diğer",
            Buyer: "Alıcılar",
            Current_commission: "Mevcut Komisyon",
            Withdraw: "Nakit para",
            Withdraw_time: "Nakit makbuz alındıktan 30 gün sonra yapılabilir",
            Share_0: "Mavi dize satış ortağı olma kuralları:",
            Share_1: "Bluedio web sitesinde 1 Temmuz 2019'dan önce yapılan harcamalar otomatik olarak blue string partnerine yükseltilecek;",
            Share_2: "1 Temmuz 2019'dan sonra, satış ortağı olarak hak kazanmak için Bluedio web sitesinden toplam 1500 ¥'a alışveriş yapmanız gerekecektir.",
            Share_3: "Sipariş altında resmi web sitesinde benim hesap numarası ile Mavi dize satış ortağı% 20 indirim;",
            Share_4: "Bluedio Satış Ortağı Kişisel Merkezi'nde Özel Dijital Kod Alır:",
            Share_5: "Satış ortağının özel dijital kodunu kullanarak ürün satın alan kullanıcılar %5 indirimden yararlanacaktır;",
            Share_6: "Dijital kodu sağlayan satış ortağı %20 komisyon bonusu alacak;",
            Share_7: "Satış ortakları, Komisyon Kazan düzenleme sütununa göre ürün satın alma durumunu öğrenebilirler;",
            Share_8: "Komisyon sütun kazandığında, bugünü bahsedebileceğinizi gösterir, Bluedio Official Withdrawal ile iletişime geçin;",
            Please_enter_the_email: "Lütfen posta kutunuzu giriniz",
            Submit: "Gönder",
            Psw_Same: "İki şifre lütfen kabul edin",
            Discount_price: "İndirimli fiyat",
            Recommendation_code: "Tavsiye kodunuz",
            Enter_your_product_code: "Ürün kodunuzu girin",
            Add_cart: "Alışveriş sepetine eklendi",
            Buy_now: "Şimdi Satın Al",
            Coupon_now: "Üye Teklifleri",
            Usr_Psw_Erro: "Kullanıcı adı veya parola hatası.",
            Not_member: "Henüz mavi bir sicim satış ortağı değilsin.",
            Can_withdraw: "Cashcants",
            Pre_acquisition: "Ön çekilme",
            Invalid: "Geçersiz",
            Commit_failed: "Başarısız gönder",
            couponTitle: "Serbest döviz, iletişim bilgileri",
            couponEmail: "E-posta",
            couponPhone: "Telefon",
            couponCountry: "ülke",
            couponContact: "İletişim",
            couponAddress: "Adres",
            couponZip: "Posta",
            Driver_Message: "7.1 Sanal Ses Kartı Sürücüsü",
            Bluedio_Mall: "Bluedio resmi mağazası",
            Bluedio_Mall_Tagline: "Profesyonel ses cihazı üreticisi",
            Bluedio_Mall_Keywords: "Bluetooth Kulaklıklar Kablosuz Kulaklıklar Gürültü önleyici Kablosuz kulaklıklar Spor için kulaklıklar Gerçekten kablosuz kulaklıklar Bluetooth kulaklık Oyun kulaklığı Kulaklık seti Kablosuz kulaklık bluetooth hoparlörler Taşınabilir Hoparlörler Bilgisayar hoparlörleri Ev sineması hoparlörleri Dış hoparlörler Kablosuz hoparlörler Dizüstü hoparlörleri Pc hoparlörleri Masaüstü hoparlörleri",
            Bluedio_Mall_Description: "Bluedio, geliştirme, üretim ve pazarlamayı birleştiren profesyonel bir ses cihazı şirketidir, bu alanda 20 yılı aşkın süredir var. Bugüne kadar biz tasarım, yazılım ve donanım geliştirme, yapı parçaları üreten, tüm cihaz montaj ve pazarlama yeteneğine sahiptir. Ve verilere dayanarak, kullanıcı merkezi ile birlikte ekolojik hizmet yeteneğini derinden geliştirmek için, bağımsız olarak ürünler geliştirmek ve üretmek için tüm endüstri zincirindeki en hızlı şirketiz. Kablosuz müziğin gelişimini teşvik etmeye kararlı olan Bluedio şirketi, dünyanın her yerindeki tüketicilerin müziğin keyfini daha rahat çıkarmak için mükemmel ses ekipmanlarına sahip olmasını hedeflemektedir.",
            Bluedio_Worry_Title: "Endişesiz Alışveriş",
            Bluedio_Worry_free: "Sorunsuz Alışveriş: Bluedio, ürünler için 30 günlük para iadesi ve bir yıl üretici garantisi sağlar......",
            Back: "İade",
            Off: "",
            Mine: "Benim",
            Home: "Ev",
            Recommend: "Tavsiye edilen",
            Chang_Lan: "Dil değiştir",
            Unpay_cancle: "Ödenmemiş siparişler 24H'dan sonra otomatik olarak silinecektir",
            Old_password: "Eski Şifre",
            Confirm_password: "Parolayı onayla",
            Remove: "Kaldır",
            Author: "Yazar",
            Published_on: "Yayınlanan",
            Contact: "Danışma",
            Modify_password_success: "Başarılı parola değişikliği",
            Modify_password_failed: "Parola değiştirilememiştir",
            Password_must_the_same: "Parola aynı olmalı",
            Region_limit: "Nakliye şu anda desteklenmiyor",
            Free_ExpressDelivery: "ücretsiz kargo,Gönderen",
            Discount_ends_in: "Teklif bitiş tarihi ",
            Discount_unit_day: "gün ",
            Following: "Takip etme:",
            Privacy_of_Policy: "Kullanım koşulları, gizlilik politikası",
            Faq: "SSS",
            Register_for_Warranty: "Kayıt Garantisi",
            Warranty_Guidelines: "Garanti Yönergeleri",
            Shipping_Returens: "Nakliye ve İade",
            Instruction_Book: "Talimat kitabı",
            Blog: "Blog",
            Gift_Box: "Hediye kutusu",
            Previous: "Önceki",
            Next: "Sonraki",
            Warranty_register_name: "ad",
            Warranty_register_email: "E-posta",
            Warranty_register_phone: "Telefon",
            Warranty_register_buyfrom: "Nereden aldın",
            Warranty_register_product: "Lütfen ürününüzü seçin",
            Warranty_register_Ordernum: "Sipariş numarası",
            Warranty_register_Serialnum: "Seri numarası",
            Warranty_register_Title: "Kayıt ol",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Şimdi üye Ol",
            Fans_discount: "Hayran Teklifi",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    pl: {
        message: {
            Categories: "Klasyfikacja towarów",
            Community: "Społeczność",
            Save: "Zapisz",
            Register: "Zarejestruj się",
            Sign_Up: "Zarejestruj się",
            Login: "Zaloguj się",
            UserName: "Nazwa użytkownika",
            News: "Nowości",
            Service: "Serwis",
            Memberships: "Członkostwo",
            AllProducts:"Wszystkie produkty",
            Aboutus: "O nas",
            Support: "Czekaj",
            Corporate: "przedsiębiorstwo",
            Customized_Service: "Usługi niestandardowe",
            APP_Download: "Pobieranie aplikacji",
            Instruction_Book: "Cookbook Download",
            Video: "Wideo",
            Forum: "Forum",
            Password: "Hasło",
            LOST_PASSWORD: "Zapomniałeś hasła?",
            Username_Email_Phone: "Nazwa użytkownika/adres e-mail/numer telefonu",
            Sign_Up_Failed: "Rejestracja nie powiodła się",
            email: "Skrzynka pocztowa",
            My_Cart: "Mój koszyk",
            CART_TOTAL: "Razem",
            POST: "Post",
            Company: "Informacje o firmie",
            Service_Item: "Przedmioty serwisu",
            Company_Dynamic: "Dynamika firmy",
            Talent_Recruitment: "Rekrutacja talentów",
            Cooperation: "Współpraca",
            After_sale: "Posprzedaż",
            Product_Verification: "Zapytanie dotyczące zwalczania fałszerstw:",
            Read_more: "Więcej",
            Commit: "Prześlij",
            Title: "Motywy",
            Please_Enter_Title: "Proszę wpisać tytuł",
            Please_Enter_Topic_Type: "Proszę wybrać temat",
            Topic_Type: "Klasyfikacja przedmiotu",
            You_need_fill_all_input: "Proszę wypełnić wszystkie opcje!!",
            Please_Log_In: "Proszę się zalogować",
            The_Comment_Is_Blank: "Komentarze nie mogą być puste!",
            STOCK: "Czas",
            QUANTITY: "Ilość",
            ADD_TO_CART: "Dodaj do koszyka",
            Product_Description: "Opis produktu",
            COLORS: "Kolor",
            COLOR: "Kolor",
            Load_More: "Załaduj więcej",
            Insufficient_quantity: "Niewystarczająca ilość",
            Add_Success: "Dodaj sukces",
            Shopping_Bag: "Koszyk",
            Checkout_Details: "Szczegóły płatności",
            Complete_Order: "Pełna płatność",
            Description: "Informacje o produkcie",
            Shipping_Itmes: "Informacje o produkcie",
            Customize_message: "Informacje niestandardowe",
            Subtotal: "Mały plan",
            Total: "Całkowity",
            Submit_Order: "Wyślij zamówienie",
            The_Cart_Empty: "Koszyk jest pusty",
            SHOPPING_CART_TOTALS: "Mój koszyk",
            Transaction_Record: "Transakcje",
            My_Order: "Lista zamówień",
            Change_Password: "Zmień hasło",
            Welcome_you: "Witamy w",
            Personal_Center: "Centrum osobiste",
            Reply: "Odpowiedz",
            Tran_Addr: "Adres wysyłk",
            Manual: "Instrukcja obsługi",
            Security: "Przeciwdziałanie podrabianiu",
            Customize: "Niestandardowe",
            Promotions: "Powiązane promocje",
            Bluedio_News: "Bluedio Aktualności",
            Product_Name: "Nazwa produktu",
            Count: "Ilość",
            Price: "Cena",
            Unpaid_Order: "Niezapłacony",
            Paid_Order: "Płatne",
            Order_Number: "Numer zamówienia",
            Order_Date: "Data",
            Payment_Way: "Metoda płatności",
            Total: "Kwota",
            Recruit: "Rekrutacja",
            Order_Status: "Status handlowy",
            Logout: "Wysuń",
            Confirm_Psw: "Potwierdź hasło",
            Retrieve_Password: "Pobierz hasło",
            Email_Not_Ass_Usr: "Nie znaleziono użytkowników skojarzonych ze skrzynką pocztową.",
            Next_Step: "Dalej",
            Welcome_to_Bluedio_mall: "Bluedio Mall wita",
            You_logout: "Nie zalogowałeś się jeszcze",
            Customize_your_product: "Niestandardowe własne produkty",
            None: "Policz to",
            Sure: "OK",
            Cancle: "Anuluj",
            Addr: "Adres",
            Tel: "Numer telefonu",
            Shipping_address: "Adres odbiorczy",
            Success: "Sukces",
            To_Checkout: "Idź do zapłaty",
            Billing_Address: "Wysyłanie adresu rozliczeniowego",
            Total_Amount: "Cena całkowita",
            Currency_Code: "Kod waluty",
            Your_Contact_Information: "Twoje dane kontaktowe",
            Telephone_Format: "Numer telefonu",
            Please_Enter_Phone: "Podaj swój numer telefonu",
            Please_Enter_UsrName: "Wprowadź nazwę użytkownika",
            Please_Enter_Passward: "Wprowadź hasło",
            Please_Enter_Passward_Again: "Wprowadź hasło ponownie",
            Please_enter_the_coupon_code: "Proszę wprowadzić kod kuponu",
            Commission_account: "Przepływ komisji",
            Brokerage: "Komisja",
            Related_Video_Recommendation: "Podobne rekomendacje wideo",
            All: "Wszystko w porządku",
            Headband: "Noszenie głowy",
            In_ear: "Do ucha",
            Sound: "Dźwięk",
            Others: "Inne",
            Buyer: "Kupujący",
            Current_commission: "Obecna Komisja",
            Withdraw: "Cash-in",
            Withdraw_time: "Gotówka może być wykonana 30 dni po otrzymaniu paragonu",
            Share_0: "Zasady, aby stać się partnerem sprzedaży niebieski ciąg:",
            Share_1: "Wydatki na stronie Bluedio przed 1 lipca 2019 r. zostaną automatycznie uaktualnione do partnera niebieskiego sznurka;",
            Share_2: "Po 1 lipca 2019 r. będziesz musiał zrobić zakupy na stronie Bluedio w sumie ¥1500, aby zakwalifikować się jako partner handlowy;",
            Share_3: "Niebieski partner handlowy ciąg z moim numerem konta na oficjalnej stronie internetowej w ramach zamówienia jest 20% zniżki;",
            Share_4: "Bluedio Sales Partner Gets Exclusive Digital Code w Osobistym Centrum",
            Share_5: "Użytkownicy nabywają produkty za pomocą ekskluzywnego kodu cyfrowego partnera handlowego otrzymają 5% zniżki;",
            Share_6: "Partner handlowy, który dostarcza kod cyfrowy, otrzyma 20% premii prowizji;",
            Share_7: "Partnerzy handlowi mogą dowiedzieć się o stanie zakupu produktu zgodnie z kolumną edycji Commission Earn;",
            Share_8: "Kiedy komisja zarabia kolumna pokazuje, że można wspomnieć o teraźniejszości, skontaktuj się z Bluedio Official Withdrawal;",
            Please_enter_the_email: "Proszę wprowadzić swoją skrzynkę pocztową",
            Submit: "Prześlij",
            Psw_Same: "Dwa hasła proszę się zgodzić",
            Discount_price: "Cena obniżona",
            Recommendation_code: "Twój kod rekomendacji",
            Enter_your_product_code: "Wprowadź kod produktu",
            Add_cart: "Dodano do koszyka",
            Buy_now: "Kup teraz",
            Coupon_now: "Oferty członkowskie",
            Usr_Psw_Erro: "Błąd nazwy użytkownika lub hasła",
            Not_member: "Nie jesteś jeszcze partnerem sprzedaży niebieskiego sznurka.",
            Can_withdraw: "Kasy",
            Pre_acquisition: "Przed wypłatą",
            Invalid: "Nieprawidłowy",
            Commit_failed: "Przesyłanie nie powiodło się",
            couponTitle: "Darmowa wymiana, informacje kontaktowe",
            couponEmail: "Email",
            couponPhone: "Telefon",
            couponCountry: "Kraj",
            couponContact: "Kontakt",
            couponAddress: "Adres",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual Sound Card Drive",
            Bluedio_Mall: "Niebieskie centrum handlowe",
            Bluedio_Mall_Tagline: "Producent profesjonalnych urządzeń audio",
            Bluedio_Mall_Keywords: "Bezprzewodowe słuchawki Bluetooth Bezprzewodowe słuchawki z redukcją szumów Bezprzewodowe słuchawki douszne Naprawdę bezprzewodowe słuchawki douszne Zestaw słuchawkowy Bluetooth Zestaw do gier Zestaw słuchawkowy Zestaw słuchawkowy Bluetooth Głośniki przenośne Głośniki Głośniki komputerowe Głośniki kina domowego Głośniki zewnętrzne Głośniki bezprzewodowe Głośniki komputerowe Głośniki komputerowe Głośniki stacjonarne",
            Bluedio_Mall_Description: "Bluedio to profesjonalna firma produkująca urządzenia audio, która łączy rozwój, produkcję i marketing. Mamy ponad 20 lat w tej dziedzinie. Do tej pory byliśmy w stanie projektować, opracowywać oprogramowanie i sprzęt, produkować części konstrukcyjne, montować całe urządzenia i wprowadzać na rynek. Opierając się na danych, wraz z centrum użytkowników wspólnie rozwijającym zdolność usług ekologicznych, jesteśmy najszybszą firmą w całym łańcuchu branżowym, która rozwija i produkuje produkty niezależnie. Firma Bluedio, zaangażowana w promowanie rozwoju muzyki bezprzewodowej, dąży do tego, aby konsumenci na całym świecie dysponowali znakomitym sprzętem audio, aby wygodniej cieszyć się muzyką.",
            Bluedio_Worry_Title: "Bezproblemowe zakupy",
            Bluedio_Worry_free: "Bezproblemowe zakupy: Bluedio zapewnia 30-dniowy zwrot pieniędzy i roczną gwarancję producenta na produkty......",
            Back: "Powrót",
            Off: "",
            Mine: "Mój",
            Home: "Strona główna",
            Recommend: "Polecam",
            Chang_Lan: "Przełącz język",
            Unpay_cancle: "Niezapłacone zamówienia zostaną automatycznie usunięte po 24H",
            Old_password: "Stare hasło",
            Confirm_password: "Potwierdź hasło",
            Remove: "Usuń",
            Author: "Autor",
            Published_on: "Opublikowany na",
            Contact: "Konsultacje",
            Modify_password_success: "Pomyślna zmiana hasła",
            Modify_password_failed: "Nie można zmienić hasła",
            Password_must_the_same: "Hasło musi być takie samo",
            Region_limit: "Wysyłka nie jest obecnie obsługiwana",
            Free_ExpressDelivery: "Szybka, darmowa wysyłka,Wysyłka z",
            Discount_ends_in: "Rabat kończy się w ",
            Discount_unit_day: "dzień ",
            Following: "Następujący:",
            Privacy_of_Policy: "Warunki użytkowania, prywatność polityki",
            Faq: "FAQ",
            Register_for_Warranty: "Zarejestruj gwarancję",
            Warranty_Guidelines: "Wytyczne gwarancyjne",
            Shipping_Returens: "Dostawa i zwroty",
            Instruction_Book: "Instrukcja",
            Blog: "Blog",
            Gift_Box: "Pudełko na prezent",
            Previous: "Poprzedni",
            Next: "Kolejny",
            Warranty_register_name: "Imię",
            Warranty_register_email: "E-mail",
            Warranty_register_phone: "Telefon",
            Warranty_register_buyfrom: "Skąd kupiłeś?",
            Warranty_register_product: "Wybierz swój produkt",
            Warranty_register_Ordernum: "Numer zamówienia",
            Warranty_register_Serialnum: "Numer seryjny",
            Warranty_register_Title: "Zarejestrować",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Zarejestruj się teraz",
            Fans_discount: "Oferta fanów",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
    jp: {
        message: {
            Categories: "商品分類",
            Community: "コミュニティ",
            Save: "保存",
            Register: "登録",
            Sign_Up: "登録",
            Login: "ログインする",
            UserName: "ユーザー名",
            News: "ニュース",
            Service: "サービス",
            Memberships: "会員",
            AllProducts:"すべての製品",
            Aboutus: "私たちに関しては",
            Support: "サポート",
            Corporate: "コーポレート",
            Customized_Service: "カスタムサービス",
            APP_Download: "APPダウンロード",
            Instruction_Book: "取扱説明書のダウンロード",
            Video: "ビデオ",
            Forum: "フォーラム",
            Password: "パスワード",
            LOST_PASSWORD: "パスワードを忘れた?",
            Username_Email_Phone: "ユーザー名/メールボックス/電話番号",
            Sign_Up_Failed: "登録に失敗しました",
            email: "メールボックス",
            My_Cart: "私のショッピングカート",
            CART_TOTAL: "合計",
            POST: "投稿",
            Company: "会社情報",
            Service_Item: "サービスプロジェクト",
            Company_Dynamic: "企業ダイナミクス",
            Talent_Recruitment: "人材採用",
            Cooperation: "協力",
            After_sale: "アフターマーケット",
            Product_Verification: "偽造防止クエリ:",
            Read_more: "もっと",
            Commit: "提出",
            Title: "トピック",
            Please_Enter_Title: "タイトルを入力してください",
            Please_Enter_Topic_Type: "トピックを選択してください",
            Topic_Type: "トピック分類",
            You_need_fill_all_input: "すべてのオプションを記入してください! ",
            Please_Log_In: "ログインしてください",
            The_Comment_Is_Blank: "コメントは空にすることはできません!",
            STOCK: "在庫",
            QUANTITY: "数量",
            ADD_TO_CART: "ショッピングカート",
            Product_Description: "製品説明",
            COLORS: "色",
            COLOR: "色",
            Load_More: "より多くのをロードし",
            Insufficient_quantity: "数量不足",
            Add_Success: "成功の追加",
            Shopping_Bag: "ショッピングカート",
            Checkout_Details: "支払いの詳細",
            Complete_Order: "支払い完了",
            Description: "製品情報",
            Shipping_Itmes: "製品情報 ",
            Customize_message: "カスタム情報 ",
            Subtotal: "小計",
            Total: "合計",
            Submit_Order: "注文の送信",
            The_Cart_Empty: "ショッピングカートは空です",
            SHOPPING_CART_TOTALS: "私のショッピングカート",
            Transaction_Record: "トランザクション",
            My_Order: "注文リスト",
            Change_Password: "パスワードの変更",
            Welcome_you: "ようこそ",
            Personal_Center: "パーソナルセンター",
            Reply: "返信",
            Tran_Addr: "配送先住所",
            Manual: "操作マニュアル",
            Security: "偽造防止",
            Customize: "カスタム",
            Promotions: "関連プロモーション",
            Bluedio_News: "Bluedio ニュース",
            Product_Name: "製品名",
            Count: "数量",
            Price: "価格",
            Unpaid_Order: "未払い",
            Paid_Order: "支払われた",
            Order_Number: "注文番号",
            Order_Date: "日付",
            Payment_Way: "支払い方法",
            Total: "金額",
            Recruit: "募集",
            Order_Status: "取引ステータス",
            Logout: "アウトアウ",
            Confirm_Psw: "確認パスワード",
            Retrieve_Password: "パスワードを取り戻す",
            Email_Not_Ass_Usr: "メールボックスに関連付けられているユーザーが見つかりません.",
            Next_Step: "次へ",
            Welcome_to_Bluedio_mall: "Bluedioモールへようこそ",
            You_logout: "まだログインしていない",
            Customize_your_product: "あなたの排他的な製品をカスタマイズする",
            None: "は",
            Sure: "OK",
            Cancle: "キャンセル",
            Addr: "アドレス",
            Tel: "電話番号",
            Shipping_address: "受信アドレス",
            Success: "成功",
            To_Checkout: "支払いに行く",
            Billing_Address: "寄付請求先住所",
            Total_Amount: "総価格",
            Currency_Code: "通貨コード",
            Your_Contact_Information: "お客様の連絡先情報",
            Telephone_Format: "電話番号",
            Please_Enter_Phone: "電話番号を入力してください",
            Please_Enter_UsrName: "ユーザー名を入力してください",
            Please_Enter_Passward: "パスワードを入力してください",
            Please_Enter_Passward_Again: "もう一度パスワードを入力してください",
            Please_enter_the_coupon_code: "クーポンコードを入力してください",
            Commission_account: "コミッションフロー",
            Brokerage: "コミッション",
            Related_Video_Recommendation: "関連ビデオ推奨",
            All: "すべて",
            Headband: "ヘッドマウント",
            In_ear: "インイヤー",
            Sound: "ステレオ",
            Others: "その他",
            Buyer: "購入者",
            Current_commission: "現在の手数料",
            Withdraw: "引き出し",
            Withdraw_time: "「受領確認後30日後に引き出し可能」",
            Share_0: "Bluedio販売パートナーになるためのルール：",
            Share_1: "2019年7月1日より前に、Bluedioの公式Webサイトにアクセスすると、自動的にアップグレードしてBluedioパートナーになることができます;",
            Share_2: "2019年7月1日以降、販売パートナーとしての資格を得るには、Bluedio Webサイトに1500以上を費やす必要があります;",
            Share_3: "Bluedioの販売パートナーはアカウントを使用して、公式Webサイトを20％割引します;",
            Share_4: "Bluedioの販売パートナーがパーソナルセンターで専用のデジタルコードを取得",
            Share_5: "ユーザーは、販売パートナーの専用デジタルコードを使用して製品を購入し、5％割引を利用できます。",
            Share_6: "デジタルコードを提供する販売パートナーには、20％の報酬が支払われます。",
            Share_7: "【手数料収入バー】により、販売パートナー様が商品の購入状況を把握できます;",
            Share_8: "[Commission Earning Bar]に利用可能な引き出しがある場合は、Bluedioの公式引き出しに連絡してください;",
            Please_enter_the_email: "メールボックスを入力してください",
            Submit: "提出",
            Psw_Same: "2つのパスワードは一貫してください",
            Discount_price: "割引価格",
            Recommendation_code: "あなたの推薦コード",
            Enter_your_product_code: "製品コードを入力してください",
            Add_cart: "カートを追加しました",
            Buy_now: "今すぐ購入",
            Coupon_now: "会員オファー",
            Usr_Psw_Erro: "ユーザー名またはパスワードエラー.",
            Not_member: "あなたはまだブルーコードの販売パートナーではありません.",
            Can_withdraw: "引き出し可能",
            Pre_acquisition: "引き出し",
            Invalid: "無効",
            Commit_failed: "コミットに失敗しました",
            couponTitle: "無料交換、連絡先情報",
            couponEmail: "Eメール",
            couponPhone: "電話",
            couponCountry: "国",
            couponContact: "連絡先",
            couponAddress: "住所",
            couponZip: "郵便番号",
            Driver_Message: "7.1仮想サウンドカードドライバ",
            Bluedio_Mall: "Bluedio公式モール",
            Bluedio_Mall_Tagline: "プロのオーディオデバイスメーカー",
            Bluedio_Mall_Keywords: "Bluetoothイヤフォンワイヤレスイヤフォンノイズキャンセリングワイヤレスイヤフォンスポーツ用イヤフォン真のワイヤレスイヤフォンBluetoothヘッドセットゲームヘッドセットヘッドセットワイヤレスヘッドセットBluetoothスピーカーポータブルスピーカーコンピュータスピーカーホームシアタースピーカー屋外スピーカーワイヤレススピーカーラップトップスピーカーPCスピーカーデスクトップスピーカー",
            Bluedio_Mall_Description: "Bluedioは、開発、製造、マーケティングを組み合わせたプロフェッショナルオーディオデバイス企業であり、この分野で20年以上の経験があります。 これまでに、設計、ソフトウェアおよびハードウェアの開発、構造部品の製造、デバイス全体の組み立ておよびマーケティングを行うことができました。 また、データに基づいて、ユーザーセンターと協力してエコロジーサービス能力を深く開発することで、私たちは業界チェーン全体で製品を独自に開発および生産する最速の企業です。 ワイヤレス音楽の開発を促進することを約束したBluedio社は、世界中の消費者に音楽をより便利に楽しむための絶妙なオーディオ機器を提供することを目指しています。",
            Bluedio_Worry_Title: "安心のショッピング",
            Bluedio_Worry_free: "安心のショッピング：Bluedioは30日間の返金と製品の1年間のメーカー保証を提供します......",
            Back: "戻る",
            Off: "",
            Mine: "私の",
            Home: "ホーム",
            Recommend: "推奨",
            Chang_Lan: "言語の切り替え",
            Unpay_cancle: "未払いの注文は24H後に自動的に削除されます",
            Old_password: "古いパスワード",
            Confirm_password: "確認パスワード",
            Remove: "削除",
            Author: "著者",
            Published_on: "リリース",
            Contact: "お問い合わせ",
            Modify_password_success: "パスワードの変更に成功しました",
            Modify_password_failed: "パスワードの変更に失敗しました",
            Password_must_the_same: "パスワードは同じでなければなりません",
            Region_limit: "現在出荷はサポートされていません",
            Free_ExpressDelivery: "送料無料,からの発送",
            Discount_ends_in: "オファーは次で終了します ",
            Discount_unit_day: "日 ",
            Following: "Following:",
            Privacy_of_Policy: "利用規約、プライバシーポリシー",
            Faq: "よくある質問",
            Register_for_Warranty: "保証の登録",
            Warranty_Guidelines: "保証ガイドライン",
            Shipping_Returens: "配送と返品について",
            Instruction_Book: "产品使用手帳",
            Blog: "ブログ",
            Gift_Box: "ギフト用の箱",
            Previous: "前",
            Next: "次",
            Warranty_register_name: "名前",
            Warranty_register_email: "Eメール",
            Warranty_register_phone: "電話",
            Warranty_register_buyfrom: "どこから購入しましたか",
            Warranty_register_product: "製品を選択してください",
            Warranty_register_Ordernum: "注文番号",
            Warranty_register_Serialnum: "シリアルナンバー",
            Warranty_register_Title: "登録",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "今すぐ登録",
            Fans_discount: "ファンオファー",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
    kr: {
        message: {
            Categories: "상품 분류",
            Community: "커뮤니티",
            Save: "저장",
            Register: "등록",
            Sign_Up: "등록",
            Login: "로그인",
            UserName: "사용자 이름",
            News: "뉴스",
            Service: "서비스",
            Memberships: "멤버십",
            AllProducts:"모든 상품",
            Aboutus: "우리에 대해",
            Support: "지원하다",
            Corporate: "법인",
            Customized_Service: "사용자 정의 서비스",
            APP_Download: "APP 다운로드",
            Instruction_Book: "요리 책 다운로드",
            Video: "비디오",
            Forum: "포럼",
            Password: "암호",
            LOST_PASSWORD: "비밀번호를 잊어버렸어?",
            Username_Email_Phone: "사용자 이름/이메일/전화 번호",
            Sign_Up_Failed: "등록 실패",
            email: "사서함",
            My_Cart: "내 장바구니",
            CART_TOTAL: "합계",
            POST: "게시물",
            Company: "회사 정보",
            Service_Item: "서비스 항목",
            Company_Dynamic: "회사 역학",
            Talent_Recruitment: "인재 채용",
            Cooperation: "협력",
            After_sale: "애프터 세일즈",
            Product_Verification: "위조 방지 쿼리: ",
            Read_more: "더",
            Commit: "제출",
            Title: "테마",
            Please_Enter_Title: "제목에 들어오십시오",
            Please_Enter_Topic_Type: "피사체를 선택해 주세요",
            Topic_Type: "주제 분류",
            You_need_fill_all_input: "모든 옵션을 입력하십시오! ",
            Please_Log_In: "로그인해 주세요",
            The_Comment_Is_Blank: "댓글은 비어 있을 수 없어!",
            STOCK: "주식",
            QUANTITY: "수량",
            ADD_TO_CART: "쇼핑 카트",
            Product_Description: "제품 설명",
            COLORS: "색상",
            COLOR: "색상",
            Load_More: "더 많은 로드",
            Insufficient_quantity: "수량 부족",
            Add_Success: "성공 추가",
            Shopping_Bag: "장바구니",
            Checkout_Details: "결제 세부 정보",
            Complete_Order: "완전 결제",
            Description: "제품 정보	",
            Shipping_Itmes: "제품 정보  ",
            Customize_message: "사용자 지정 정보	",
            Subtotal: "작은 계획",
            Total: "합계",
            Submit_Order: "주문 제출",
            The_Cart_Empty: "장바구니가 비어 있습니다.",
            SHOPPING_CART_TOTALS: "내 장바구니",
            Transaction_Record: "거래",
            My_Order: "주문 목록",
            Change_Password: "비밀번호를 변경하십시오",
            Welcome_you: "오신 것을 환영합니다",
            Personal_Center: "개인 센터",
            Reply: "답장",
            Tran_Addr: "배송 주소",
            Manual: "연산자 매뉴얼",
            Security: "위조 방지",
            Customize: "사용자 정의",
            Promotions: "관련 프로모션",
            Bluedio_News: "블루 스트링 뉴스",
            Product_Name: "제품 이름",
            Count: "수량",
            Price: "가격",
            Unpaid_Order: "무급",
            Paid_Order: "유료",
            Order_Number: "주문 번호",
            Order_Date: "날짜",
            Payment_Way: "결제 방법",
            Total: "양",
            Recruit: "채용",
            Order_Status: "거래 상태",
            Logout: "게시물 아웃",
            Confirm_Psw: "비밀번호 확인",
            Retrieve_Password: "암호 검색",
            Email_Not_Ass_Usr: "사서함과 연관된 사용자가 발견되지 않았습니다.",
            Next_Step: "다음",
            Welcome_to_Bluedio_mall: "블루 스트링 몰 은 당신을 환영합니다",
            You_logout: "아직 로그인하지 않았습니다.",
            Customize_your_product: "사용자 정의 할 수 있습니다",
            None: "카운트 업",
            Sure: "괜찮아요",
            Cancle: "취소",
            Addr: "주소",
            Tel: "의 전화 번호",
            Shipping_address: "주소 수신",
            Success: "성공",
            To_Checkout: "유료로 이동",
            Billing_Address: "결제 주소 보내기",
            Total_Amount: "총 가격",
            Currency_Code: "통화 코드",
            Your_Contact_Information: "연락처 정보",
            Telephone_Format: "전화 번호",
            Please_Enter_Phone: "전화번호를 입력해 주세요",
            Please_Enter_UsrName: "사용자 이름을 입력해 주세요",
            Please_Enter_Passward: "비밀번호를 입력해주세요",
            Please_Enter_Passward_Again: "암호를 다시 입력하십시오",
            Please_enter_the_coupon_code: "쿠폰 코드 입력 해주세요",
            Commission_account: "커미션 플로우 유입",
            Brokerage: "커미션",
            Related_Video_Recommendation: "관련 비디오 권장 사항",
            All: "모두",
            Headband: "「머리 착용」",
            In_ear: "귀 속으로",
            Sound: "사운드",
            Others: "기타",
            Buyer: "구매자",
            Current_commission: "현재 위원회",
            Withdraw: "현금",
            Withdraw_time: "영수증 수령 후 30일 이내에 현금을 함께 할 수 있습니다.",
            Share_0: "파란색 문자열 판매 파트너가 되기 위한 규칙:",
            Share_1: "2019년 7월 1일 이전에 블루 스트링 웹사이트에 지출하면 자동으로 파란색 문자열 파트너로 업그레이드됩니다;",
            Share_2: "2019년 7월 1일 이후에는 판매 파트너자격을 얻으려면 총 1,500엔의 Blue String 웹사이트에서 쇼핑을 해야 합니다;",
            Share_3: "주문에 따라 공식 웹 사이트에서 내 계정 번호와 블루 문자열 판매 파트너는 20 % 할인;",
            Share_4: "블루 문자열 판매 파트너는 개인 센터에서 독점 디지털 코드를 가져옵니다",
            Share_5: "판매 파트너의 독점 디지털 코드를 사용하여 제품을 구매하는 사용자는 5% 할인을 받게 됩니다",
            Share_6: "디지털 코드를 제공하는 영업 파트너는 20%의 수수료 보너스를 받게 됩니다",
            Share_7: "판매 파트너는 위원회 적립 편집 칼럼에 따라 제품 구매 상태를 확인할 수 있습니다",
            Share_8: "커미션이 칼럼을 통해 현재를 언급할 수 있음을 보여 주면 블루스트링 공식 철회에 문의하십시오;",
            Please_enter_the_email: "사서함을 입력해주세요.",
            Submit: "제출",
            Psw_Same: "두 개의 암호가 동의하시기 바랍니다",
            Discount_price: "할인 가격",
            Recommendation_code: "추천 코드",
            Enter_your_product_code: "제품 코드를 입력",
            Add_cart: "장바구니에 추가",
            Buy_now: "지금 구매",
            Coupon_now: "회원 혜택",
            Usr_Psw_Erro: "사용자 이름 또는 암호 오류.",
            Not_member: "아직 블루 문자열 판매 파트너가 아닙니다.",
            Can_withdraw: "캐쉬캔트",
            Pre_acquisition: "사전 인출",
            Invalid: "잘못되었습니다",
            Commit_failed: "실패한 제출",
            couponTitle: "무료 교환 ・ 연락처",
            couponEmail: "이메일",
            couponPhone: "전화",
            couponCountry: "국가",
            couponContact: "접촉",
            couponAddress: "주소",
            couponZip: "지퍼",
            Driver_Message: "7.1 가상 사운드 카드 드라이브",
            Bluedio_Mall: "블루 스트링 몰",
            Bluedio_Mall_Tagline: "전문 오디오 장치 제조업체",
            Bluedio_Mall_Keywords: "블루투스 이어폰 무선 이어폰 소음 제거 무선 이어폰 스포츠 용 이어폰 진정한 무선 이어폰 블루투스 헤드셋 게임 헤드셋 헤드셋 무선 헤드셋 블루투스 스피커 휴대용 스피커 컴퓨터 스피커 홈 시어터 스피커 실외 스피커 무선 스피커 노트북 스피커 PC 스피커 데스크탑 스피커",
            Bluedio_Mall_Description: "Bluedio는 개발, 제조 및 마케팅을 결합한 전문 오디오 장치 회사로서이 분야에서 20 년이 넘는 경험을 보유하고 있습니다. 지금까지 우리는 설계, 소프트웨어 및 하드웨어 개발, 구조 부품 생산, 전체 장치 조립 및 마케팅을 수행 할 수있었습니다. 또한 생태 서비스 능력을 심층적으로 개발하기 위해 사용자 센터와 함께 데이터를 기반으로 전체 산업 체인에서 독립적으로 제품을 개발하고 생산하는 가장 빠른 회사입니다. Bluedio 회사는 무선 음악 개발을 촉진하기 위해 전 세계 소비자들이 음악을보다 편리하게 즐길 수있는 정교한 오디오 장비를 갖도록하는 것을 목표로하고 있습니다.",
            Bluedio_Worry_Title: "걱정없는 쇼핑",
            Bluedio_Worry_free: "걱정없는 쇼핑 : Bluedio는 제품에 대해 30 일 환불 및 1 년 제조업체 보증을 제공합니다......",
            Back: "리턴",
            Off: "",
            Mine: "내",
            Home: "집",
            Recommend: "추천",
            Chang_Lan: "언어 전환",
            Unpay_cancle: "24H 이후 미결제 주문이 자동으로 삭제됩니다",
            Old_password: "오래된 암호",
            Confirm_password: "비밀번호 확인",
            Remove: "제거",
            Author: "저자",
            Published_on: "에 게시",
            Contact: "상담",
            Modify_password_success: "성공적인 암호 변경",
            Modify_password_failed: "암호를 변경하지 못했습니다",
            Password_must_the_same: "암호는 동일해야 합니다",
            Region_limit: "배송은 현재 지원되지 않습니다",
            Free_ExpressDelivery: "무료 배송,에서 배송",
            Discount_ends_in: "제안은에 종료됩니다 ",
            Discount_unit_day: "일 ",
            Following: "수행원:",
            Privacy_of_Policy: "이용 약관, 개인 정보 보호 정책",
            Faq: "자주하는 질문",
            Register_for_Warranty: "보증 등록",
            Warranty_Guidelines: "보증 지침",
            Shipping_Returens: "배송 및 반품",
            Instruction_Book: "설명서",
            Blog: "블로그",
            Gift_Box: "선물 상자",
            Previous: "이전",
            Next: "다음",
            Warranty_register_name: "이름",
            Warranty_register_email: "이메일",
            Warranty_register_phone: "전화",
            Warranty_register_buyfrom: "어디서 사셨습니까?",
            Warranty_register_product: "제품을 선택하십시오",
            Warranty_register_Ordernum: "주문 번호",
            Warranty_register_Serialnum: "일련 번호",
            Warranty_register_Title: "레지스터",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "지금 등록하세요",
            Fans_discount: "팬 제공",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    //-----------------------------------------------add 7lan--------------------------------------------------------
    in: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    vn: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
    th: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

    my: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
    id: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
ph: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },
sa: {
        message: {
            Categories: "Categories",
            Community: "Community",
            Save: "Save",
            Register: "Register",
            Sign_Up: "Sign Up",
            Login: "Login",
            UserName: "UserName",
            News: "News",
            Service: "Service",
            Memberships: "Memberships",
            AllProducts:"All Products",
            Aboutus: "About US",
            Support: "Support",
            Corporate: "Corporate Enquiry",
            Customized_Service: "Customized Service",
            APP_Download: "APP Download",
            Instruction_Book: "Instruction Book",
            Video: "Video",
            Forum: "Forum",
            Password: "Password",
            LOST_PASSWORD: "LOST PASSWORD?",
            Username_Email_Phone: "UserName/Email/Phone",
            Sign_Up_Failed: "Sign up failed",
            email: "Email",
            My_Cart: "My Cart",
            CART_TOTAL: "Cart Total",
            POST: "POST",
            Company: "Company",
            Service_Item: "Service",
            Company_Dynamic: "Company Dynamic",
            Talent_Recruitment: "Talent Recruitment",
            Cooperation: "Cooperation",
            After_sale: "After sale",
            Product_Verification: "Product Verification:",
            Read_more: "Read more",
            Commit: "Commit",
            Title: "Title",
            Please_Enter_Title: "Please Enter Title",
            Please_Enter_Topic_Type: "Please Enter Topic Type",
            Topic_Type: "Topic Type",
            You_need_fill_all_input: "You need fill all input!!",
            Please_Log_In: "Please Login",
            The_Comment_Is_Blank: "The comment is blank!",
            STOCK: "Stock",
            QUANTITY: "Quantity",
            ADD_TO_CART: "Add to Cart",
            Product_Description: "Product Description",
            COLORS: "Colors",
            COLOR: "Color",
            Load_More: "Load More",
            Insufficient_quantity: "Insufficient quantity",
            Add_Success: "Add Success",
            Shopping_Bag: "Cart",
            Checkout_Details: "Checkout Details",
            Complete_Order: "Complete Order",
            Description: "Description",
            Shipping_Itmes: "Item(s)",
            Customize_message: "Customize",
            Subtotal: "Subtotal",
            Total: "Total",
            Submit_Order: "Submit Order",
            The_Cart_Empty: "The cart is empty",
            SHOPPING_CART_TOTALS: "SHOPPING CART TOTALS",
            Transaction_Record: "Transaction Record",
            My_Order: "My Order",
            Change_Password: "Change Password",
            Welcome_you: "Welcome",
            Personal_Center: "Personal Center",
            Reply: "Reply",
            Tran_Addr: "Delivery address",
            Manual: "Manual",
            Security: "Security",
            Customize: "Customize",
            Promotions: "Promotions",
            Bluedio_News: "Bluedio News",
            Product_Name: "Product Name",
            Count: "Count",
            Price: "Price",
            Unpaid_Order: "Unpaid orders",
            Paid_Order: "Paid Order",
            Order_Number: "Order Number",
            Order_Date: "Order Date",
            Payment_Way: "Payment Way",
            Total: "Total",
            Recruit: "Recruit",
            Order_Status: "Order Status",
            Logout: "Logout",
            Confirm_Psw: "Confirm password",
            Retrieve_Password: "Retrieve Password",
            Email_Not_Ass_Usr: "Did not find mail associated users.",
            Next_Step: "Next Step",
            Welcome_to_Bluedio_mall: "Welcome to Bluedio mall",
            You_logout: "You are not logged in yet",
            Customize_your_product: "Customize your product",
            None: "None",
            Sure: "Sure",
            Cancle: "Cancle",
            Addr: "Address",
            Tel: "Tel.",
            Shipping_address: "Shipping Address",
            Success: "Success",
            To_Checkout: "To Checkout",
            Billing_Address: "Billing Address",
            Total_Amount: "Total Amount",
            Currency_Code: "Currency Code",
            Your_Contact_Information: "Your Contact Information",
            Telephone_Format: "Telephone Format",
            Please_Enter_Phone: "Please Enter Phone",
            Please_Enter_UsrName: "Please Enter Name",
            Please_Enter_Passward: "Please Enter Password",
            Please_Enter_Passward_Again: "Please enter the password again",
            Please_enter_the_coupon_code: "Please enter the coupon code",
            Commission_account: "Commission Flow",
            Brokerage: "Brokerage",
            Related_Video_Recommendation: "Related Video Recommendation",
            All: "All",
            Headband: "Headband",
            In_ear: "In-ear",
            Sound: "Sound",
            Others: "Others",
            Buyer: "Buyer",
            Current_commission: "Current commission",
            Withdraw: "Withdraw",
            Withdraw_time: "Confirmation can be withdrawn 30 days after receipt",
            Share_0: "Rules to become a member of Bluedio:",
            Share_1: "Customers,who purchase our products on Bluedio offcial store before July 1,2019 will become Bluedio members;",
            Share_2: "After July 1,2019,still,you will gain a opportunity to be a member when your orders amount exceed to $200;",
            Share_3: "Bluedio members will be eligible for a 20% discount when they purchase products with their own account on the offical store;",
            Share_4: "Members acquires a personal code on the Personal Central;",
            Share_5: "User will get a 5% discount when they purchase Bluedio's products with member's personal code;",
            Share_6: "Member who share their code to the user will receive a 20% commission;",
            Share_7: "Member can realize about Order Status according to Commission Flow;",
            Share_8: "Please contact our customer-services staff to help to withdrawal when the Commission Flow show that you're allow to withdrawal;",
            Please_enter_the_email: "Please enter the email",
            Submit: "Submit",
            Psw_Same: "Please enter the same password twice",
            Discount_price: "Discount price",
            Recommendation_code: "Your recommendation code",
            Enter_your_product_code: "Enter your product code",
            Add_cart: "Successful addition of shopping carts",
            Buy_now: "Buy Now",
            Coupon_now: "Member benefits",
            Usr_Psw_Erro: "The email and password you entered did not match. Please try again.",
            Not_member: "You are not the Bluedio member yet.",
            Can_withdraw: "Can withdraw",
            Pre_acquisition: "Pre-acquisition",
            Invalid: "Invalid",
            Commit_failed: "Commit failed",
            couponTitle: "Free exchange, contact information",
            couponEmail: "Email",
            couponPhone: "Phone",
            couponCountry: "Country",
            couponContact: "Contact",
            couponAddress: "Address",
            couponZip: "ZIP",
            Driver_Message: "7.1 Virtual sound card driver",
            Bluedio_Mall: "Bluedio official store",
            Bluedio_Mall_Tagline: "professional audio device manaufacturer",
            Bluedio_Mall_Keywords: "Bluetooth Earbuds Wireless Earphones Noise cancelling Wireless earphones Earphones for sport Truly wireless earbuds Bluetooth headset Gaming headset Headset Wireless headset bluetooth speakers Portable Speakers Computer speakers Home theater speakers Outdoor speakers Wireless speakers Laptop speakers Pc speakers Desktop speakers ",
            Bluedio_Mall_Description: "Bluedio is a professional audio device company who combine developing, manufacturing and marketing, we have over 20 years in this field. By far we have been capable of designing, software and hardware developing, structure parts producing, whole device assembling and marketing. And based on data, with user center together to develop ecological service ability deeply, we are the fastest company in the whole industry chain to develop and produce products independently. Committed to promote the development of wireless music, Bluedio company take the aim of making the consumers all around the world have exquisite audio equipment to enjoy music more conveniently.",
            Bluedio_Worry_Title: "Worry-free Shopping",
            Bluedio_Worry_free: "Worry-free Shopping:Bluedio provide 30-day money back and one year manufacturer's warranty on the products......",
            Back: "back",
            Off: "Off",
            Mine: "Mine",
            Home: "Home",
            Recommend: "Recommend",
            Chang_Lan: "Switch Language",
            Unpay_cancle: "Unpaid orders are automatically deleted after 24H",
            Old_password: "Old password",
            Confirm_password: "Confirm password",
            Remove: "Remove",
            Author: "Author",
            Published_on: "Published on",
            Contact: "Contact",
            Modify_password_success: "Modify password success",
            Modify_password_failed: "Modify password failed",
            Password_must_the_same: "password must the same",
            Region_limit: "Sorry, shipping is not supported in your area.",
            Free_ExpressDelivery: "Fast,Free Shipping,Shipping from",
            Discount_ends_in: "Discount ends in ",
            Discount_unit_day: "day ",
            Following: "Following:",
            Privacy_of_Policy: "Terms of Use , Privacy of Policy",
            Faq: "FAQ",
            Register_for_Warranty: "Register Warranty",
            Warranty_Guidelines: "Warranty Guidelines",
            Shipping_Returens: "Shipping & Returens",
            Instruction_Book: "Instruction Book",
            Blog: "Blog",
            Gift_Box: "Gift Box",
            Previous: "Previous",
            Next: "Next",
            Warranty_register_name: "Name",
            Warranty_register_email: "Email",
            Warranty_register_phone: "Phone",
            Warranty_register_buyfrom: "Where did you buy from",
            Warranty_register_product: "Please select your product",
            Warranty_register_Ordernum: "Order Number",
            Warranty_register_Serialnum: "Serial Number",
            Warranty_register_Title: "Register",
            Warranty_register_subTitle: "YOUR NOISE PRODUCT",
            Warranty_register_submit: "Register Now",
            Fans_discount: "Fan Offer",
            Download_title: "7.1 Virtual sound card driver",
            Download_desc: "If you can’t download, please copy the following URL to your browser and open ",
            Download_url: "http://cn.service.bluedio.com/sound7_1.zip",
        },
    },

};
const numberFormats = {
    en: {
        currency: {
            style: "currency",
            currency: "USD",
        },
    },
    cn: {
        currency: {
            style: "currency",
            currency: "RMB",
            currencyDisplay: "symbol",
        },
    },

    
};
export default new VueI18n({
    locale: localStorage.getItem("lan") == null ? "en" : localStorage.getItem("lan"), // set locale
    messages, 
    numberFormats,
});